import { MultiCourseCompetitionService } from 'services/multi-course-competition-service/multi-course-competition.service';
import { devMode } from './../../../../globals';
import { CommonPullupMenuComponent } from './../../modal-screens/common-pullup-menu/common-pullup-menu.component';
import { DeleteRoomModalComponent } from './../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import {
  NavController,
  Platform,
  NavParams,
  ActionSheetController,
  ModalController,
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import * as moment from 'moment';
import {
  CompetitionInfo,
  CompetitionDetails,
  createCompetitionDetails,
  FlightInfo,
  Leaderboard,
  createLeaderboardDetails,
  CompetitionPlayerInfo,
  CompetitionTeams,
} from './../../../../data/competition-data';
import { ClubMembership, PlayerInfo } from './../../../../data/player-data';
import { ServerResult } from './../../../../data/server-result';
import {
  GameRoundInfo,
  createGameRoundInfo,
  PlayerHomeInfo,
  PlainScoreCard,
  FlightMember,
  CompetitionRoundCourseRatings,
  LeagueRound,
  CompetitionData,
  GameRoundData,
  CompetitionRoundSession,
  FlightMoreData,
  CompetitionPlayerData,
  CompetitionWaitList,
  LeagueSeason,
  MergedCompetitionDetails,
  CompetitionFeeApplicable,
  CompetitionMatch,
  CompPlayerParticipation,
  CompetitionMatchParticipant,
  CompetitionTeamPlayerData,
  LeagueNature,
  CompetitionTeamWithPlayersView,
  CompetitionPlayerFullView,
  CompetitionSponsorData,
  CompetitionTeamRoundFlight,
  DynamicForm,
  PlayerData,
} from './../../../../data/mygolf.data';

import { CompetitionService } from './../../../../providers/competition-service/competition-service';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { AuthenticationService } from 'src/authentication-service';

import { MessageDisplayUtil } from './../../../../message-display-utils';
import { PlayerService } from './../../../../providers/player-service/player-service';
import {
  AbstractNotificationHandlerPage,
  NotificationHandlerInfo,
} from './../../../../providers/pushnotification-service/notification-handler-constructs';
import { ScorecardDisplayPage } from './../../scorecard-display/scorecard-display.page';

import { adjustViewZIndex } from 'src/globals';

import { SessionInfo } from './../../../../data/authentication-info';
import { SessionDataService } from './../../../../redux/session/session-data-service';

import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { CurrentScorecardActions, CurrentScorecardDataService } from 'src/redux/scorecard';
import { Observable, Subscription, forkJoin, from, of, finalize, firstValueFrom } from 'rxjs';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';

//

import { NavigationExtras, Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { CoursesModalPage } from '../competitions-modal/courses-modal/courses-modal.page';
import { DescriptionModalPage } from '../competitions-modal/description-modal/description-modal.page';
import { FullInfoModalPage } from '../competitions-modal/full-info-modal/full-info-modal.page';
import { RulesModalPage } from '../competitions-modal/rules-modal/rules-modal.page';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ExpandCompetitionLogo } from './competition-details-expand-logo';
import { CompetitionPaymentConfirm } from './competition-payment-confirmation.page';
import { Location } from '@angular/common';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

import * as global from 'src/globals';
import { CompetitionLeagueMenuPage } from '../competition-league-menu/competition-league-menu.page';
import { PaymentSelectionPage } from '../../booking/booking-details/payment-selection/payment-selection.page';
import { CompetitionPaymentSelectionPage } from '../competition-payment-selection/competition-payment-selection.page';
import { resolve } from 'url';
import { SUBSCRIBE_COMP_SHOW_LEADERBOARD, WebsocketActions } from 'src/redux/wstomp';

import { DateTime } from 'luxon';
import { CompetitionFormModalPage } from '../../modal-screens/competition-form/competition-form.page';
import { JsonService } from 'src/json-util';
import { CompEventsDetailsComponent } from '../../comp-events/comp-events-details/comp-events-details.component';

// import { CompetitionFulDetailsPage } from './competition-full-details';
@Component({
  selector: 'app-competition-details',
  templateUrl: './competition-details.page.html',
  styleUrls: ['./competition-details.page.scss'],
  providers: [NavParams],
})
export class CompetitionDetailsPage implements OnInit, OnDestroy {
  scorecard: PlainScoreCard;
  competition: MergedCompetitionDetails;
  compId: number;
  details: CompetitionDetails;
  flights: Array<FlightMoreData> = new Array<FlightMoreData>();
  leaderBoard: Leaderboard;
  currentRound = 1;
  gameRound: GameRoundInfo;
  countDays: number;
  countDaysText: string;
  countDaysRound: number;
  scoringRound = 0;
  freshCompInfo = true;
  clubName: string;
  memberships: Array<ClubMembership> = [];
  // compTeams: CompetitionTeams;
  compTeams: Array<CompetitionTeamWithPlayersView> = [];
  roundList: Array<number> = [];

  needRefresh = true;
  session: SessionInfo;

  showTeam = false;

  currentPlayer: PlayerInfo;

  flightPublished = true;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  playerIsPlaying: Array<any>;

  isEclectic = false;

  compData: CompetitionData;
  compSessions: Array<CompetitionRoundSession>;
  fromScorecard = false;

  constructor(
    private router: Router,
    private loadingCtl: LoadingController,
    private compService: CompetitionService,
    private nav: NavController,
    private navParams: NavParams,
    private platform: Platform,
    private actionSheetCtl: ActionSheetController,
    private alertCtl: AlertController,
    private toastCtl: ToastController,
    private renderer: Renderer2, // private playerHomeService: PlayerHomeDataService
    private modalCtl: ModalController,
    private auth: AuthenticationService,
    private scorecardService: ScorecardService,
    private sessionService: SessionDataService,
    private playerService: PlayerService,

    private playerHomeActions: PlayerHomeActions,
    private currentScorecardActions: CurrentScorecardActions,
    private playerHomeService: PlayerHomeDataService,
    private currentScorecardService: CurrentScorecardDataService,
    private flightService: ClubFlightService,
    private route: ActivatedRoute,
    private location: Location,
    private mg2uUtils: mygolfUtils,
    private websocketActions: WebsocketActions,
    private multiCourseCompService: MultiCourseCompetitionService
  ) {
    console.debug(
      'check redirect home',
      this.router.getCurrentNavigation().extras.state,
      this.platform.getQueryParam('compRegister')
    );
    if (
      !this.router.getCurrentNavigation().extras.state &&
      !this.platform.getQueryParam('compRegister')
    ) {
      this.goHome();
    }

    this.competition = this.router.getCurrentNavigation().extras.state.competition;
    this.fromScorecard = this.router.getCurrentNavigation().extras.state.fromScoring;
    this.details = createCompetitionDetails();
    this.leaderBoard = createLeaderboardDetails();
    this.gameRound = createGameRoundInfo();
    this.flights = new Array<FlightMoreData>();
    this.compId = this.router.getCurrentNavigation().extras.state.compId;
    this.compData = this.router.getCurrentNavigation().extras.state.compData;

    if (this.competition?.id || this.competition?.competitionId || this.compId) {
      // this.compId = this.competition?.id;

      this.refreshCompData();
      this.getPlayerApplicableFee().then(() => {});
      // let _compId = this.compId;
      // this.flightService.getCompetitionDetails(_compId)
      // .subscribe((compData)=>{
      //   if(compData) this.compData = compData;
      //   this.compService.setCompData(compData);
      //   console.debug("get comp data", compData, this.compData);
      //   this._checkCompetitionSessions();
      // })
    }

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    this.player$ = this.playerHomeInfo$
      .pipe(filter(Boolean))
      .pipe(map((playerHome: any) => playerHome));
    if (this.fromScorecard) {
      this.onRefreshClick(null);
    }
    console.debug(
      'view did load ',
      this.fromScorecard,
      this.competition,
      this.compData,
      this.router.getCurrentNavigation().extras.state
    );

    this.initWebsocketActions();
  }
  ngOnInit() {}

  ionViewDidLoad() {}

  ionViewDidEnter() {
    this.sessionService
      .getSession()
      .pipe(take(1))
      .subscribe((session: SessionInfo) => {
        this.session = session;
      });

    adjustViewZIndex(this.nav, this.renderer);
    if (this.needRefresh) {
      this.needRefresh = false;
      this.refreshPage(false);
    }
  }

  ionViewDidLeave() {
    this.compService.clearCompData();
    if (this.subShowLeaderboard) {
      this.subShowLeaderboard.unsubscribe();
      this.subShowLeaderboard = null;
    }

    if (this.subCompDetails) {
      this.subCompDetails.unsubscribe();
      this.subCompDetails = null;
    }
    if (this.subNewCompTeams) {
      this.subNewCompTeams.unsubscribe();
      this.subNewCompTeams = null;
    }
  }

  ionViewWillEnter() {
    const _fromFlight = this.navParams.get('fromFlight');
    if (_fromFlight) {
      this.flightPublished = this.navParams.get('flightPublished');
    }

    if (!this.flightPublished) {
      const subTitle = 'Flights have not been published yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Flights', subTitle);
    }
  }
  async deriveSession() {
    this.session = await this.sessionService.getSession().toPromise();
  }
  refreshPage(pushData: any) {
    this.onRefreshClick(null);
  }

  public getNotifications(): Array<NotificationHandlerInfo> {
    const notifications = new Array<NotificationHandlerInfo>();
    notifications.push({
      type: AbstractNotificationHandlerPage.TYPE_COMP_INFO_CHANGED,
      whenActive: 'showToast',
      needRefresh: true,
    });
    return notifications;
  }

  onRefreshClick(refresher) {
    this.freshCompInfo = true;
    this.goingToPay = false;
    this._refreshCompetitionInfo(refresher);
    this.refreshCompData();
    this.getPlayerApplicableFee().then(() => {});
  }

  private async _refreshCompetitionInfo(refresher, attribute?: string) {
    const loader = await this.loadingCtl.create({
      message: 'Please wait...',
      showBackdrop: true,
      duration: 5000,
    });
    loader.onDidDismiss().then(() => {
      if (refresher) {
        refresher.detail.complete();
      }
    });
    loader.present().then(() => {
      (this.compService
        .getCompetitionInfo(this.compId)
        .subscribe((comp: MergedCompetitionDetails) => {
          this.competition = comp;
          // this.flightService
          //   .checkLeagueCompetition(
          //     this.competition ? this.compId : this.compId
          //   )
          //   .subscribe((data) => {
          //     this.isEclectic = data;
          //     if(this.isEclectic) {
          //       this.getLeagueSeason();
          //     }
          //   });
          this._init();
          //Get competition details
          this.compService.getDetails(this.compId).subscribe(
            (details: any) => {
              this.details = details;
              this.getCompRoundCourseRatings();
              //Get the scoring round
              this.compService.getScoringRoundNumber(this.compId).subscribe(
                (roundNo: number) => {
                  this.scoringRound = roundNo;
                  //Get players
                  // this.compService.getPlayersRegistered(this.compId).subscribe(
                  //   (players: any) => {
                  //     this.details.players = players;
                  //     let _player;
                  //     this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
                  //       if (player) _player = player;
                  //     });

                  //     this.playerIsPlaying = this.details.players.filter(
                  //       (compPlayer: CompetitionPlayerInfo) => {
                  //         if (compPlayer && compPlayer.playerId && _player && _player.playerId) {
                  //           return compPlayer.playerId === _player.playerId;
                  //         } else return false;
                  //       }
                  //     );

                  //     this.competition.totalRegistered = this.details.players.length;
                  this.refreshCompetitionTeams(loader, refresher, attribute);
                  //   },
                  //   error => {
                  //     //Error getting comp players
                  //     loader.dismiss().then(() => {
                  //       this._onRefreshComplete();
                  //     });
                  //   }
                  // );
                },
                error => {
                  //Error getting scoring round
                  this.scoringRound = 0;
                  loader.dismiss(() => {
                    this._onRefreshComplete();
                    const msg = MessageDisplayUtil.getErrorMessage(
                      error,
                      'Error getting scoring round'
                    );
                    // MessageDisplayUtil.showErrorToast(
                    //   msg,
                    //   this.platform,
                    //   this.toastCtl,
                    //   3000,
                    //   'bottom'
                    // );
                    this.onErrorMessage('Scorecard', 'Error getting scoring round');
                  });
                }
              );
            },
            error => {
              loader.dismiss(() => {
                this._onRefreshComplete();
                const msg = MessageDisplayUtil.getErrorMessage(
                  error,
                  'Error getting competition details'
                );
                // MessageDisplayUtil.showErrorToast(
                //   msg,
                //   this.platform,
                //   this.toastCtl,
                //   3000,
                //   'bottom'
                // );
                this.onErrorMessage('Competition', 'Error getting competition details');
              });
            }
          );

          // this.doRefresh(refresher, loader);
        }),
        error => {
          loader.dismiss().then(() => {
            this._onRefreshComplete();
            const msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error getting competition information'
            );
            // MessageDisplayUtil.showErrorToast(
            //   msg,
            //   this.platform,
            //   this.toastCtl,
            //   3000,
            //   'bottom'
            // );
            this.onErrorMessage('Competition', 'Error getting competition information');
          });
        },
        () => {});
    });
  }

  private _onRefreshComplete() {
    if (this.freshCompInfo) {
      // if (this.currentRound == null) {
      if (this.competition.status == 'Completed') {
        this.currentRound = this.competition.totalRounds;
      } else {
        this.currentRound = this.details.roundInProgress;
        if (!this.currentRound) {
          this.currentRound = this.details.nextRound;
        }
        if (!this.currentRound) {
          this.currentRound = 1;
        }
      }
    }
    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo, idx: number) => gr.roundNo == this.currentRound)
      .pop();
    this.roundList = [];

    for (let i = 1; i <= this.competition.totalRounds; i++) {
      this.roundList.push(i);
    }

    adjustViewZIndex(this.nav, this.renderer);

    // this.getPlayerInfo();
  }

  private refreshPlayers() {
    this.compService.getPlayersRegistered(this.compId).subscribe((players: any) => {
      this.details.players = players;
      this.competition.totalRegistered = this.details.players.length;
    });
  }

  private _init() {
    var b = moment();
    var a = moment(this.competition.startDate);

    this.countDays = a.diff(b, 'days', true) + 1;
    this.countDays = Math.round(this.countDays * 100) / 100;
    this.countDaysRound = a.diff(b, 'days') + 1; // =1

    if (this.countDays >= 0.0 && this.countDays <= 0.99) {
      this.countDaysText = 'Starts today';
    }
    if (this.countDays < 0) {
      this.countDaysText = 'Not started yet';
    }
    if (this.countDays >= 1.0 && this.countDays <= 1.99) {
      this.countDaysText = 'Starts tomorrow ';
    }
    if (this.countDays >= 2) {
      this.countDaysText = 'Starts in ' + this.countDaysRound + ' days';
    }
  }

  public roundNoToDisplay(): string {
    if (this.details && this.details.roundInProgress) {
      return 'R' + this.details.roundInProgress;
    } else if (this.details && this.details.nextRound) {
      return 'R' + this.details.nextRound;
    } else {
      return 'R1';
    }
  }

  async openMenu() {
    const actionSheet = await this.actionSheetCtl.create({
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel', // will always sort to be on the bottom
          icon: !this.platform.is('ios') ? 'close' : null,
          handler: () => {},
        },
      ],
    });

    const roundNo = this.competition.totalRounds;
    for (let i = 1; i <= roundNo; i++) {
      actionSheet.buttons.push({
        text: 'Round ' + i,
        role: 'destructive',
        icon: 'filter',
        handler: () => {
          this.currentRound = i;
          //  this.roundInfo = this.getSelectedRoundInfo();
          //this.doRefresh(null);
          //+ this.roundInfo.id
          this.gameRound = this.details.gameRounds
            .filter((gr: GameRoundInfo) => gr.roundNo == this.currentRound)
            .pop();
          this.freshCompInfo = false;
          this._refreshCompetitionInfo(null);

          //  this.goScorecard();
        },
      });
    }

    actionSheet.present();
  }

  checkBtnRegister() {
    if (this.compData?.waitListSize > 0 && this.isWaitListed()) {
      return false;
    }
    // const clubTimeZone = this.compData?.club?.timeZone?.id;
    // const openDateTime = `${this.compData?.openDate}T${this.compData?.registrationOpenTime}`;
    // const closeDateTime = `${this.compData?.closeDate}T${this.compData?.registrationCloseTime}`;
    // const openTime = DateTime.fromISO(openDateTime, { zone: clubTimeZone });
    // const closeTime = DateTime.fromISO(closeDateTime, { zone: clubTimeZone });
    // const currTime = DateTime.now(); // DateTime.fromISO('2025-06-04T02:00:00', { zone: 'UTC' });
    // if (
    //   this.competition.status != 'Completed' &&
    //   !this.isClosedForRegistration() &&
    //   !this.isRegistered()
    // ) {
    //   if (openTime.toUTC() <= currTime.toUTC() && closeTime.toUTC() >= currTime.toUTC())
    //     return true;
    // }

    // console.debug("check btn REGISTER", this.competition)
    if (
      this.competition.status != 'Completed' &&
      !this.isClosedForRegistration() &&
      !this.isRegistered()
    ) {
      return true;
    }
    // this.competition.closedForRegistration == false
  }

  checkBtnDeRegister() {
    if (this.compData?.waitListSize > 0 && this.isWaitListed()) {
      return true;
    }
    // console.debug("check btn DE-REGISTER", this.competition)
    if (
      this.competition.status != 'Completed' &&
      this.competition.status != 'In Progress' &&
      !this.isClosedForRegistration() &&
      this.isRegistered()
    ) {
      return true;
    }

    // this.competition.closedForRegistration === false
  }

  getSelectedRoundInfo() {
    return this.details.gameRounds
      .filter((gr: GameRoundInfo) => gr.roundNo == this.currentRound)
      .pop();
  }

  async CompetitionDetailsModal() {
    const modal = await this.modalCtl.create({
      component: FullInfoModalPage,
      componentProps: { competition: this.competition, compId: this.compId },
    });
    modal.present();
  }

  getPlayerInFlight() {
    if (!this.flights) {
      return;
    }
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerInFlight;

    _playerInFlight = this.flights.filter((flight: FlightMoreData) => {
      // return flight.playerFlight;
      const _playerFlight = flight.flightMembers.filter(
        flightMember => flightMember?.player?.playerId === _player?.playerId
      );
      if (_playerFlight?.length > 0) {
        flight.playerFlight = true;
      }
      return _playerFlight;
    });

    // console.debug("get player in flight", _playerInFlight, _player, this.flights);

    if ((_playerInFlight && _playerInFlight.length === 0) || !_playerInFlight) {
      return false;
    } else {
      return true;
    }
  }

  async goScorecard() {
    const loader = await this.loadingCtl.create({
      message: 'Getting scorecard. Please wait...',
    });
    if (this.competition.status == 'Upcoming') {
      const subTitle = 'Competition has not started';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onShowMessage('Info', subTitle);
      return false;
    }

    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerInFlight;
    _playerInFlight = this.flights.filter((flight: FlightMoreData) => flight.playerFlight);
    // this.flights.filter((flight)=>{
    //   _playerInFlight = flight.flightMembers.filter((flightMember)=>{
    //     return flightMember.playerId === _player.playerId
    //   })
    // });

    // if(_playerInFlight && _playerInFlight.length === 0 || !_playerInFlight) {
    if (!this.getPlayerInFlight()) {
      const _msg = 'You are not playing in this round.';
      // MessageDisplayUtil.showErrorToast(
      //   _msg,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );
      this.onErrorMessage('Scorecard', _msg);
      return false;
    }

    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo, idx: number) => gr.roundNo == this.currentRound)
      .pop();

    loader.present().then(() => {
      this.scorecardService.getScorecard(this.gameRound.id).subscribe(
        (scorecard: PlainScoreCard) => {
          loader.dismiss().then(() => {
            this.scorecard = scorecard;
            let _player: PlayerInfo;
            this.player$.pipe(take(1)).subscribe(player => {
              _player = player;
            });
            if (this.scorecard.success) {
            }

            const navigationExtras: NavigationExtras = {
              state: {
                scorecard: this.scorecard,
                competition: this.competition,
                compId: this.compId,
                gameRound: this.gameRound,
                isCompetition: true,
                editing: true,
                currentPlayer: _player,
              },
            };
            this.router.navigate(['scorecard-display'], navigationExtras);
          });
        },
        error => {
          //let title = "No Sponsors";
          console.debug('getting scorecard : ', error?.error);
          if (loader) {
            loader.dismiss();
          }

          let _error;
          let subTitle;
          // if(error?.error?.json()) {
          //   _error = error.json();
          //   subTitle = _error.message;
          // } else
          subTitle = error?.error?.message;
          // MessageDisplayUtil.displayErrorAlert(
          //   this.alertCtl,
          //   '',
          //   subTitle,
          //   'OK'
          // );

          this.onErrorMessage('Flights', subTitle);
        },
        () => {
          //if (isPresent(this.gameRound)) {
        }
      );
    });
    //if(this.scorecard.success){

    //            this.nav.push(ScorecardPage, {

    /*	} else {
     let title = "No Sponsors";
     let subTitle = this.scorecard.message;
     MessageDisplayUtil.displayInfoAlert(this.alertCtl, "", subTitle, "OK");
     }
     */
  }

  async initPageLoader(message: string = '') {
    this.pageLoader = await this.loadingCtl.create({
      cssClass: 'custom-loading',
      message: message,
      backdropDismiss: false,
      // duration: 3000,
      showBackdrop: true,
    });
  }

  compScoringClicked = false;
  pageLoader: HTMLIonLoadingElement | null = null; // any;
  routerSubscriptions: Subscription[] = []; // Track router subscriptions for cleanup
  async onCompetitionScoringClick() {
    try {
      if (this.compScoringClicked) {
        return;
      }
      this.compScoringClicked = true;
      await this.initPageLoader('Getting scorecard. Please wait...');
      console.debug(
        'on comp scoring click',
        this.currentRound,
        this.details,
        this.competition,
        this.gameRound,
        this.getPlayerStatus()
      );
      if (!this.currentRound) {
        return;
      }
      if (!this.competition) {
        return;
      }
      if (this.competition && !this.compId) {
        return;
      }
      if (this.getPlayerStatus() === 'Withdrawn') {
        const _msg = 'You have Withdrawn from the competition. Please go to View Scorecard instead';
        this.onShowMessage('Scorecard', _msg);
        return false;
      }

      // let loader = await this.loadingCtl.create({
      //   message: "Getting scorecard. Please wait...",
      //   backdropDismiss: false
      // });
      let _player: PlayerInfo;
      this.player$.pipe(take(1)).subscribe(player => {
        _player = player;
      });
      let _competitionId;
      let _isScorer;
      // this.scorecardService.clearScorecard().subscribe((scorecard)=>{

      // });

      const _today = moment().format('YYYY-MM-DD');
      const _startDate = moment(this.competition.startDate).format('YYYY-MM-DD');
      const _endDate = moment(this.competition.endDate).format('YYYY-MM-DD');

      if (_startDate > _today && _endDate < _today) {
        const _msg = 'Competition is not active anymore';
        // MessageDisplayUtil.showErrorToast(
        //   _msg,
        //   this.platform,
        //   this.toastCtl,
        //   3000,
        //   'bottom'
        // );

        console.debug('on comp scoring [1] ', _msg);
        this.onErrorMessage('Scorecard', _msg);
        return false;
      } else if (_endDate < _today) {
        const _msg = 'Competition is not active anymore';
        // MessageDisplayUtil.showErrorToast(
        //   _msg,
        //   this.platform,
        //   this.toastCtl,
        //   3000,
        //   'bottom'
        // );
        console.debug('on comp scoring [2] ', _msg);
        this.onErrorMessage('Scorecard', _msg);
        return false;
      }

      // this.flights.filter((flight)=>{

      //   flight.flightMembers.filter((flightMember)=>{
      //     flightMember.playerId === return
      //   })
      // })
      // if(loader) loader.present();
      this.compService.getScorers(this.compId, this.currentRound).subscribe(data => {
        if (data) {
          let _playerInFlight;
          // this.compService
          //   .getFlights(
          this.flightService
            .getCompFlightList(this.compId, this.currentRound)
            .subscribe((flights: any) => {
              flights.filter(flight => {
                _playerInFlight = flight.flightMembers.filter(
                  flightMember => flightMember?.player?.playerId === _player.playerId
                );
              });
            });
          // if(_playerInFlight && _playerInFlight.length === 0 || !_playerInFlight) {
          if (!this.getPlayerInFlight()) {
            const _msg = 'You are not playing in this round.';
            // MessageDisplayUtil.showErrorToast(
            //   _msg,
            //   this.platform,
            //   this.toastCtl,
            //   3000,
            //   'bottom'
            // );
            this.onErrorMessage('Scorecard', _msg);
            return false;
          }
          _isScorer = data.filter(data => data.playerId === _player.playerId);

          this.pageLoader.present();
          setTimeout(() => {
            if (this.playerIsPlaying && this.playerIsPlaying.length > 0) {
              this.scorecardService.getCurrentScorecard().subscribe(
                async (scorecard: PlainScoreCard) => {
                  if ((scorecard && scorecard.competitionId !== this.compId) || !scorecard) {
                    if ((_isScorer && _isScorer.length === 0) || !_isScorer) {
                      this.scorecardService
                        .getScorecard(this.details.gameRounds[this.currentRound - 1].id)
                        .subscribe(
                          (scorecard: PlainScoreCard) => {
                            // if (loader) loader.dismiss();
                            const navigationExtras: NavigationExtras = {
                              state: {
                                scorecard: scorecard,
                                competition: this.competition,
                                compId: this.compId,
                                currentPlayer: _player,
                                editingScorecard: _isScorer && _isScorer.length > 0 ? true : false,
                              },
                            };
                            this.router
                              .navigate(['gameround-scoring'], navigationExtras)
                              .then(async () => {
                                const routerSub = await this.router.events.subscribe(
                                  async event => {
                                    console.debug(
                                      'trying to dismiss : ',
                                      event,
                                      event instanceof NavigationEnd
                                    );
                                    if (event instanceof NavigationEnd) {
                                      this.compScoringClicked = false;
                                      // if (this.pageLoader)
                                      await this.pageLoader.dismiss();
                                    }
                                  }
                                );
                                this.routerSubscriptions.push(routerSub);
                              });
                          },
                          error => {
                            const _error = error.json();

                            const _msg = _error.message;
                            // MessageDisplayUtil.showErrorToast(
                            //   _msg,
                            //   this.platform,
                            //   this.toastCtl,
                            //   3000,
                            //   'bottom'
                            // );
                            this.onErrorMessage('Scorecard', _msg);
                            return false;
                          }
                        );
                    } else if (_isScorer && _isScorer.length > 0) {
                      const loader = await this.loadingCtl.create({
                        message: 'Getting scorecard. Please wait...',
                      });
                      loader.present().then(() => {
                        const _getCompetitionScoring = this.playerHomeActions.getCompetitionScoring(
                          this.compId,
                          _player.playerId,
                          loader
                        );

                        let getScorecardTimeout;
                        const getScorecard = setInterval(() => {
                          this.scorecardService.getCurrentScorecard().subscribe(
                            (scorecard: PlainScoreCard) => {
                              if (scorecard && scorecard.competitionId === this.compId) {
                                clearInterval(getScorecard);
                                clearTimeout(getScorecardTimeout);
                                this.compService.getCompetitionInfo(this.compId).subscribe(
                                  (comp: MergedCompetitionDetails) => {
                                    loader.dismiss().then(() => {
                                      this.currentScorecardActions.setScoringPlayer(
                                        _player.playerId
                                      );
                                      let navigationExtras: NavigationExtras = {
                                        state: {
                                          scorecard: scorecard,
                                          competition: comp,
                                          currentPlayer: _player,
                                        },
                                      };
                                      this.router
                                        .navigate(['gameround-scoring'], navigationExtras)
                                        .then(async () => {
                                          const routerSub = await this.router.events.subscribe(
                                            async event => {
                                              console.debug(
                                                'trying to dismiss : ',
                                                event,
                                                event instanceof NavigationEnd
                                              );
                                              if (event instanceof NavigationEnd) {
                                                this.compScoringClicked = false;
                                                // if (this.pageLoader)
                                                await this.pageLoader.dismiss();
                                              }
                                            }
                                          );
                                          this.routerSubscriptions.push(routerSub);
                                        });
                                    });
                                  },
                                  error => {
                                    if (loader) {
                                      loader.dismiss();
                                    }
                                    clearInterval(getScorecard);
                                    clearTimeout(getScorecardTimeout);
                                  },
                                  () => {
                                    // if(loader) loader.dismiss();
                                  }
                                );
                              }
                            },
                            error => {
                              if (loader) {
                                loader.dismiss();
                              }
                              clearInterval(getScorecard);
                              clearTimeout(getScorecardTimeout);
                              this.scorecardService
                                .getScorecard(this.details.gameRounds[this.currentRound - 1].id)
                                .subscribe(
                                  (scorecardNon: PlainScoreCard) => {
                                    let navigationExtras: NavigationExtras = {
                                      state: {
                                        scorecard: scorecardNon,
                                        competition: this.competition,
                                        compId: this.compId,
                                        currentPlayer: _player,
                                        editingScorecard: false,
                                      },
                                    };
                                    this.router
                                      .navigate(['gameround-scoring'], navigationExtras)
                                      .then(async () => {
                                        const routerSub = await this.router.events.subscribe(
                                          async event => {
                                            console.debug(
                                              'trying to dismiss : ',
                                              event,
                                              event instanceof NavigationEnd
                                            );
                                            if (event instanceof NavigationEnd) {
                                              this.compScoringClicked = false;
                                              // if (this.pageLoader)
                                              await this.pageLoader.dismiss();
                                            }
                                          }
                                        );
                                        this.routerSubscriptions.push(routerSub);
                                      });
                                    //
                                  },
                                  error => {
                                    if (loader) {
                                      loader.dismiss();
                                    }
                                    let _error = error.json();

                                    let _msg = _error.message;
                                    // MessageDisplayUtil.showErrorToast(
                                    //   _msg,
                                    //   this.platform,
                                    //   this.toastCtl,
                                    //   3000,
                                    //   'bottom'
                                    // );
                                    this.onErrorMessage('Scorecard', _msg);
                                    return false;
                                  }
                                );
                            },
                            () => {
                              //  clearInterval(getScorecard)
                            }
                          );
                        }, 3000);

                        // Add timeout protection - clear interval after 30 seconds
                        getScorecardTimeout = setTimeout(() => {
                          clearInterval(getScorecard);
                          if (loader) {
                            loader.dismiss();
                            console.error('Scorecard fetch timeout after 30 seconds');
                          }
                        }, 30000);
                      });
                    }
                  } else {
                    // if (loader) loader.dismiss();
                    if (scorecard) {
                      _competitionId = scorecard.competitionId;
                    } else {
                      _competitionId = this.compId ? this.compId : this.compId;
                    }
                    this.compService
                      .getCompetitionInfo(_competitionId)
                      .subscribe((comp: MergedCompetitionDetails) => {
                        this.playerService
                          .getPlayerInfo(this.session.playerId)
                          .subscribe(async (player: PlayerInfo) => {
                            if (scorecard) {
                              const navigationExtras: NavigationExtras = {
                                state: {
                                  scorecard: scorecard,
                                  competition: comp,
                                  currentPlayer: player,
                                },
                              };
                              this.router
                                .navigate(['gameround-scoring'], navigationExtras)
                                .then(async () => {
                                  const routerSub = await this.router.events.subscribe(
                                    async event => {
                                      console.debug(
                                        'trying to dismiss : ',
                                        event,
                                        event instanceof NavigationEnd
                                      );
                                      if (event instanceof NavigationEnd) {
                                        this.compScoringClicked = false;
                                        // if (this.pageLoader)
                                        await this.pageLoader.dismiss();
                                      }
                                    }
                                  );
                                  this.routerSubscriptions.push(routerSub);
                                });
                            } else {
                              const loader = await this.loadingCtl.create({
                                message: 'Getting scorecard. Please wait...',
                              });

                              let _compId;
                              // this.playerHomeInfo$.filter(Boolean).subscribe((a: PlayerHomeInfo)=>{
                              //     if(a.compsActiveToday && a.compsActiveToday.length > 0)
                              //     _compId = a.compsActiveToday[0].competitionId
                              // });
                              _compId = this.compId;
                              this.playerHomeActions.getCompetitionScoring(
                                _compId,
                                this.session.playerId,
                                loader
                              );
                              let getScorecardTimeout;
                              const getScorecard = setInterval(() => {
                                this.scorecardService
                                  .getCurrentScorecard()
                                  .subscribe((scorecard: PlainScoreCard) => {
                                    if (scorecard) {
                                      clearInterval(getScorecard);
                                      clearTimeout(getScorecardTimeout);
                                      this.compService.getCompetitionInfo(_compId).subscribe(
                                        (comp: MergedCompetitionDetails) => {
                                          // loader.dismiss().then(() => {
                                          this.currentScorecardActions.setScoringPlayer(
                                            this.session.playerId
                                          );

                                          let navigationExtras: NavigationExtras = {
                                            state: {
                                              scorecard: scorecard,
                                              competition: comp,
                                              currentPlayer: _player,
                                            },
                                          };
                                          this.router
                                            .navigate(['gameround-scoring'], navigationExtras)
                                            .then(async () => {
                                              const routerSub = await this.router.events.subscribe(
                                                async event => {
                                                  console.debug(
                                                    'trying to dismiss : ',
                                                    event,
                                                    event instanceof NavigationEnd
                                                  );
                                                  if (event instanceof NavigationEnd) {
                                                    this.compScoringClicked = false;
                                                    // if (this.pageLoader)
                                                    await this.pageLoader.dismiss();
                                                  }
                                                }
                                              );
                                              this.routerSubscriptions.push(routerSub);
                                            });

                                          // });
                                        },
                                        error => {
                                          if (loader) {
                                            loader.dismiss();
                                          }
                                          clearInterval(getScorecard);
                                          clearTimeout(getScorecardTimeout);
                                        },
                                        () => {
                                          if (loader) {
                                            loader.dismiss();
                                          }
                                        }
                                      );
                                    }
                                  });
                              }, 1000);

                              // Add timeout protection - clear interval after 30 seconds
                              getScorecardTimeout = setTimeout(() => {
                                clearInterval(getScorecard);
                                if (loader) {
                                  loader.dismiss();
                                  console.error('Scorecard fetch timeout after 30 seconds');
                                }
                              }, 30000);
                            }
                          });
                      });
                  }
                },
                error => {}
              );
            }
          }, 1000);
        }
      });

      // if(1) return;

      // if (this.scoringRound > 0) {
    } finally {
      // Ensure pageLoader is always dismissed, even on early returns
      this.compScoringClicked = false;
      if (this.pageLoader) {
        try {
          await this.pageLoader.dismiss();
        } catch (e) {
          // Ignore dismissal errors if already dismissed
          console.debug('pageLoader dismissal error:', e);
        }
      }
    }
  }

  compSponsorsList: Array<CompetitionSponsorData> = [];
  goSponsors() {
    if (this.compSponsorsList.length < 1) {
      // let subTitle = 'No sponsors have been defined for this competition'; //'Sponsors have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Sponsors', 'No sponsors have been defined for this competition');
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          sponsors: this.compSponsorsList, // || this.details.sponsors,
        },
      };
      this.router.navigate(['tabs/competition-sponsors'], navigationExtras);
    }
  }

  goPrizes() {
    if (this.prizeCount() < 1) {
      const subTitle = 'No Prizes have been defined for this competition'; //'Prizes have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Prizes', subTitle);
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          prizes: this.details.prizes,
          teamPrizes: this.details.teamPrizes,
          categories: this.compData.categories,
          compDataPrizes: this.compData.prizes,
          compData: this.compData,
        },
      };
      console.debug('going grouping prizes - details : ', this.details.prizes);
      console.debug('going grouping prizes - compData : ', this.compData?.prizes);
      this.router.navigate(['tabs/competition-prizes'], navigationExtras);
    }
  }
  toggleTeamEvent(type) {
    if (type == 'individual') {
      this.showTeam = false;
    } else if (type == 'team') {
      this.showTeam = true;
    }

    this.goLeaderboard();
  }
  // goTeamLeaderboard(){
  //   this.showTeam = true;
  //
  //   this.goLeaderboard();
  // }

  ngOnDestroy() {
    this.ionViewWillLeave();
  }
  ionViewWillLeave() {
    if (this.pageLoader) {
      this.pageLoader.dismiss();
    }
    // Cleanup router subscriptions to prevent memory leaks
    this.routerSubscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
    this.routerSubscriptions = [];
  }
  goLeaderboard() {
    // this._refreshCompetitionInfo(null);
    if (this.competition.status == 'Upcoming' || this.competition.status == 'Not Started') {
      // let subTitle =
      //   'Competition has not started. Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        '',
        'Competition has not started. Please refresh to view latest competition status.'
      );
      return false;
    }
    if (!this.competition.showLeaderBoard) {
      // let subTitle =
      //   'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        'Leaderboard',
        'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.'
      );
      return false;
    }
    if (this.currentRound == null) {
      this.currentRound = this.details.roundInProgress;
      if (!this.currentRound) {
        this.currentRound = this.details.nextRound;
      }
    }
    if (this.currentRound != null) {
      const navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          leaderboards: this.leaderBoard,
          leaderboardPlayers: this.leaderBoard.players,
          roundNo: this.currentRound,
          categories: this.details.categories,
          teams: this.competition.teamEvent ? null : null,
          showTeam: this.showTeam,
          compData: this.compData,
        },
      };
      this.router.navigate(['tabs/competition-leaderboard'], navigationExtras);
    }
  }

  goPlayers() {
    if (this.playerViews.length < 1) {
      const subTitle = 'Players have not registered for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Players', subTitle);
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          players: this.playerViews,
          roundNo: this.currentRound,
          categories: this.details.categories,
        },
      };
      this.router.navigate(['tabs/competition-players'], navigationExtras);
    }
  }

  async onImageClick() {
    const modal = await this.modalCtl.create({
      component: ExpandCompetitionLogo,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        competition: this.competition,
        compId: this.compId,
      },
    });
    await modal.present();
  }
  goFlights(attribute?: string) {
    if (this.gameRound.status === 'Pending' && !attribute) {
      this._refreshCompetitionInfo(null, 'refreshFlight');
      return false;
    }

    if (this.gameRound && this.gameRound.status === 'Pending' && !this.gameRound.publishFlights) {
      let _multipleRounds = false;
      if (this.competition && this.competition.totalRounds > 1) {
        _multipleRounds = true;
      }

      let subTitle;
      if (_multipleRounds) {
        subTitle = 'Flights for round ' + this.gameRound.roundNo + ' have not been published yet.';
      }
      //'Flights have not been defined for this competition yet';
      else if (!_multipleRounds) {
        subTitle = 'Flights have not been published yet';
      }
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Flights', subTitle);
      return false;
    }
    if (this.flights.length < 1) {
      const subTitle = 'No flights have been defined for this round'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Flights', subTitle);
      return false;
      /*  let alert = Alert.create({
       title: 'No Flights',
       subTitle: 'There is no flight assigned for this competition',
       buttons: ['OK']
       });
       this.nav.present(alert);*/
    } else {
      console.debug('this current round : ', this.currentRound);
      this.gameRound = this.details.gameRounds.find(
        (gr: GameRoundInfo, idx: number) => gr.roundNo == this.currentRound
      );
      // .pop();
      const navigationExtras: NavigationExtras = {
        state: {
          competitionId: this.compId,
          competition: this.competition,
          compId: this.compId,
          roundNo: this.gameRound.roundNo,
          gameRound: this.gameRound,
          flights: this.flights,
        },
      };
      this.router.navigate(['tabs/competition-flights'], navigationExtras);
    }
  }

  goTeams() {
    if (this.compTeams?.length == 0) {
      const subTitle = 'No teams have been assigned to this competition'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Teams', subTitle);
      return false;
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          flights: this.flights,
          gameRound: this.gameRound,
          compTeams: this.compTeams,
          compData: this.compData,
        },
      };
      // alert('Navigation Left to set');
      this.router.navigate(['tabs/competition-teams'], navigationExtras);
    }
  }
  goHome() {
    console.debug('redirect to home');
    this.router.navigate(['tabs/player-home']);
  }

  onBackpage() {
    this.location.back();
    // this.router.navigate(['tabs/competition-list'], { replaceUrl: false });
  }
  private async onClubRegisterClick(clubId: number) {
    const alert2 = await this.alertCtl.create({
      //title: 'Confirm register',
      header: 'Registration',
      message:
        'This competition is only for <b>' +
        this.competition?.club?.name +
        '</b>. Are you a member of the club?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            alert2.dismiss();
          },
        },
        {
          text: 'Yes',
          handler: () => {
            alert2.dismiss().then(() => {
              this.openMembershipOptions(clubId);
            });
          },
        },
      ],
    });
    alert2.present();
  }

  // private _addMembershipAndRegister(){
  //
  // }
  async openMembershipOptions(clubId: number, membership?: string) {
    const prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message:
        'Enter your Membership Number for <b>' +
        this.competition?.club?.name +
        '</b> and click Save',
      inputs: [
        {
          name: 'title',
          placeholder: 'Membership Number',
          value: membership,
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss();
            return false;
          },
        },
        {
          text: 'Save',
          handler: data => {
            if (data && data.title) {
              prompt.dismiss().then(() => {
                this._addMembership(clubId, data.title);
              });
            } else {
              // MessageDisplayUtil.showErrorToast(
              //   'You have not entered membership number',
              //   this.platform,
              //   this.toastCtl,
              //   5000,
              //   'bottom'
              // );
              this.onErrorMessage('Register', 'You have not entered membership number');
            }

            return false;
          },
        },
      ],
    });
    prompt.present();
  }

  private _addMembership(clubId: number, membership: string) {
    this.playerService.updateClubMembership(clubId, membership).subscribe(
      () => {
        // this._refreshMemberships();
      },
      error => {},
      () => {
        this.register();
      }
    );
  }

  public async onRegisterClick() {
    this.goingToPay = false;
    // await this.refreshCompData();
    const joiningWaitList = this.isJoiningWaitlist();
    if (this.compData.paymentMandatory && !joiningWaitList) {
      this.goPaymentInfo();
      return;
    }
    if (this._checkCompetitionSessions()) {
      this.flightService.getCompetitionDetails(this.compData.id).subscribe(
        compData => {
          if (compData) {
            this.compData = compData;
            // this.getRegisteredPlayers();
            this.getRegisteredPlayerViews();
            this.compService.setCompData(compData);
          }
          console.debug('get comp data', compData, this.compData);
          this._checkCompetitionSessions();
        },
        error => {},
        () => {
          this.goRegisterJoinSession();
        }
      );
      return;
    }
    // let canRegister: boolean = false;
    if (this.competition.type == 'Members') {
      this.getPlayerMembership(this.competition?.club?.name);
      return false;
    } else {
      let _header = 'Registration';
      let _msg = 'Are you sure you want to register?';
      const _subMsg = '';
      if (this.compData?.waitListSize > 0) {
        if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
          if (this.getTotalWaitList() < this.compData.waitListSize && !this.isWaitListed()) {
            _header = 'Join Wait List';
            _msg = 'Are you sure you want to Join Wait List?';
          }
        }
      }
      const modal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'notification',
          header: _header,
          msg: _msg,
          subMsg: _subMsg,
        },
      });
      await modal.present();
      modal.onDidDismiss().then(async data => {
        if (data) {
          if (data?.data === 'confirm') {
            if (this.compAddInfoForm) {
              try {
                this.register();
                // const done = await this.goFillMissingInfo();
                // if (done) {
                // }
              } catch (error) {
                this.register();
              }
            } else {
              this.register();
            }
          }
        }
      });
    }
  }

  private async register(ignoreOverlap: boolean = false, sessionId?: number) {
    let _message = 'Registering...';
    if (this.compData?.waitListSize > 0) {
      if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
        if (this.getTotalWaitList() < this.compData.waitListSize) {
          _message = 'Joining...';
        }
      }
    }
    const register = await this.loadingCtl.create({
      showBackdrop: false,
      message: _message,
    });

    register.present().then(() => {
      // this.compService
      // .register(
      this.flightService
        .compRegisterPlayer(this.compId, this.session.playerId, ignoreOverlap, sessionId)
        .subscribe(
          (result: ServerResult) => {
            console.debug('_newRegister OLD registering to  : ', register);
            register.dismiss().then(async () => {
              if (result.success || result) {
                // this.competition.registered = true;
                // MessageDisplayUtil.showMessageToast(
                //   result.message,
                //   this.platform,
                //   this.toastCtl,
                //   3000,
                //   'bottom'
                // );
                let _msg = 'You are successfully registered to participate in the competition.';
                if (this.compAddInfoForm && this.needPayment())
                  _msg += ' Please complete the form before payment';
                let _title = 'Registration';
                if (this.compData?.waitListSize > 0) {
                  if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
                    if (this.getTotalWaitList() < this.compData.waitListSize) {
                      _title = 'Join Wait List';
                    }
                    _msg = 'You have succesfully joined Wait List in the competition.';
                  }
                }
                if (result?.message) {
                  _msg = result.message;
                }

                this.onShowMessage(_title, _msg);
                this.refreshPlayers();
                this.refreshCompData();
                if (this.compAddInfoForm) {
                  this.goFillMissingInfo();

                  let _toastMessage = _msg;
                  MessageDisplayUtil.showMessageToast(
                    _toastMessage,
                    this.platform,
                    this.toastCtl,
                    10000,
                    'bottom',
                    'primary',
                    'stacked'
                  );
                  // this.onShowMessage(_title, _msg);
                }
                // else this.onShowMessage(_title, _msg);
              } else {
                this._conditionalRegister(result.message);
              }
              this.getPlayerApplicableFee().then(() => {});
            });
          },
          error => {
            register.dismiss().then(() => {
              console.debug('registering to club member only : ', error);
              const _error = error.error;
              let _modifiedMsg: string;
              const msg = MessageDisplayUtil.getErrorMessage(
                _error,
                'Error occured while registering for this comptetition. Try again later.'
              );
              if (
                _error?.errorMessage?.length > 0 &&
                _error?.errorMessage?.toLowerCase().includes('already registered')
              ) {
                _modifiedMsg = this.mg2uUtils.wrapReplaceNextWordAfter(
                  _error?.errorMessage,
                  'competition',
                  'b'
                );
              } else {
                _modifiedMsg = _error?.errorMessage;
              }

              if (_error?.errorCode === 'Competition.OverlapRegistration') {
                this.onOverlapRegister(_modifiedMsg);
                return;
              }
              // MessageDisplayUtil.showErrorToast(
              //   msg,
              //   this.platform,
              //   this.toastCtl,
              //   5000,
              //   'bottom'
              // );
              // 'Error occured while registering for this comptetition. Try again later.'
              this.onErrorMessage('Register', _modifiedMsg);
            });
          }
        );
    });
  }

  async onOverlapRegister(message?: string) {
    const _header = 'Overlapped Registration';
    let _msg = 'Do you still want to Register this competition?';
    if (message) {
      _msg = message + '<br>' + _msg;
    }
    const _subMsg = '';
    const modal = await this.modalCtl.create({
      component: CommonPullupMenuComponent, // DeleteRoomModalComponent,
      // showBackdrop:true,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        mode: 'negative-confirmation',
        headerTitle: _header,
        confirmMessage: _msg,
      },
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      if (data) {
        if (data?.data) {
          this.register(true);
        }
      }
    });
  }

  private async _newRegister(
    ignoreOverlap: boolean = false,
    sessionId?: number,
    suppressMessage: boolean = false,
    feeTypeSelected?: string,
    membershipNo?: string
  ) {
    return new Promise(async (resolve, reject) => {
      let _message = 'Registering...';
      if (suppressMessage) {
        _message = '';
      }
      if (this.compData?.waitListSize > 0) {
        if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
          if (this.getTotalWaitList() < this.compData.waitListSize) {
            _message = 'Joining...';
          }
        }
      }
      const register = await this.loadingCtl.create({
        showBackdrop: false,
        message: _message,
      });

      register.present().then(() => {
        // this.compService
        // .register(
        this.flightService
          .compRegisterPlayer(
            this.compId,
            this.session.playerId,
            ignoreOverlap,
            sessionId,
            feeTypeSelected,
            membershipNo
          )
          .subscribe(
            (result: ServerResult) => {
              console.debug('_newRegister --- registering to  : ', result);
              register.dismiss().then(() => {
                let _msg = 'You are successfully registered to participate in the competition.';
                if (this.compAddInfoForm && this.needPayment())
                  _msg += ' Please complete the form before payment';
                let _title = 'Registration';
                if (result.success || result) {
                  // this.competition.registered = true;
                  // MessageDisplayUtil.showMessageToast(
                  //   result.message,
                  //   this.platform,
                  //   this.toastCtl,
                  //   3000,
                  //   'bottom'
                  // );
                  if (this.compData?.waitListSize > 0) {
                    if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
                      if (this.getTotalWaitList() < this.compData.waitListSize) {
                        _title = 'Join Wait List';
                      }
                      _msg = 'You have succesfully joined Wait List in the competition.';
                    }
                  }
                  if (result?.message) {
                    _msg = result.message;
                  }

                  if (!suppressMessage) {
                    this.onShowMessage(_title, _msg);
                  }
                  this.refreshPlayers();
                  this.refreshCompData();
                } else {
                  this._conditionalRegister(result.message);
                }
                this.getPlayerApplicableFee()
                  .then((result2: any) => {
                    if (result2) {
                      resolve({
                        result: result,
                        title: _title,
                        message: _msg,
                      });
                    }
                  })
                  .catch(error => {
                    resolve(result);
                  });
              });
            },
            error => {
              register.dismiss().then(() => {
                console.debug('registering to club member only : ', error?.error?.errorMessage);
                let _modifiedMsg = '';
                let _error = error?.error;
                const msg = MessageDisplayUtil.getErrorMessage(
                  _modifiedMsg,
                  'Error occured while registering for this competition. Try again later.'
                );
                if (
                  _error?.errorMessage.length > 0 &&
                  _error?.errorMessage?.toLowerCase().includes('already registered')
                ) {
                  _modifiedMsg = this.mg2uUtils.wrapReplaceNextWordAfter(error, 'competition', 'b');
                } else {
                  _modifiedMsg = _error?.errorMessage;
                }
                // MessageDisplayUtil.showErrorToast(
                //   msg,
                //   this.platform,
                //   this.toastCtl,
                //   5000,
                //   'bottom'
                // );
                // 'Error occured while registering for this comptetition. Try again later.'
                this.onErrorMessage('Register', _modifiedMsg);
                this.goingToPay = false;
                reject(error?.error);
              });
            }
          );
      });
    });
  }

  private async _conditionalRegister(msg: string) {
    const confirmOverlap = await this.alertCtl.create({
      header: 'Competition Registration',
      message: msg + '. Do you want to still register for this competition ?',
      buttons: [
        {
          text: 'No',
          role: 'Cancel',
          handler: () => {
            confirmOverlap.dismiss();
            return false;
          },
        },
        {
          text: 'Register',
          handler: () => {
            confirmOverlap.dismiss(true);
            return false;
          },
        },
      ],
    });
    confirmOverlap.onDidDismiss().then(data => {
      if (data) {
        this.register(true);
      }
    });
    confirmOverlap.present();
  }

  async onDeregisterClick() {
    if (0) {
      //old design
      const alert = await this.alertCtl.create({
        //title: 'Confirm de-register',
        header: 'De-Register', // 'Confirm to de-register from this competition?',
        message: 'Are you sure you want to de-register from this competition?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
              alert.dismiss();
              return false;
            },
          },
          {
            text: 'Yes',
            handler: () => {
              alert.dismiss().then(() => {
                this.deregister();
              });
              return false;
            },
          },
        ],
      });
      alert.present();
    } else {
      let _header = 'De-Register';
      let _msg = 'Are you sure you want to de-register from this competition?';
      const _subMsg = '';
      if (this.isWaitListed()) {
        _header = 'Remove from Wait List';
        _msg = 'Are you sure you want to be de-listed from Wait List?';
      }
      const modal = await this.modalCtl.create({
        component: DeleteRoomModalComponent,
        showBackdrop: true,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          mode: 'notification',
          header: _header,
          msg: _msg,
          subMsg: _subMsg,
        },
      });
      await modal.present();
      modal.onDidDismiss().then(data => {
        if (data) {
          if (data?.data === 'confirm') {
            if (this.isWaitListed()) {
              this.removeFromWaitList();
            } else {
              this.deregister();
            }
            // itemSliding?itemSliding.close():null;
            // this.reloadScorecard(false, false);
          }
        }
      });
    }
  }

  async deregister() {
    const busy = await this.loadingCtl.create({
      message: 'Deregistering...',
    });
    busy.present().then(() => {
      this.compService.deregister(this.compId, this.session.playerId).subscribe(
        (result: ServerResult) => {
          busy.dismiss().then(() => {
            // this.competition.registered = false;
            // MessageDisplayUtil.showMessageToast(
            //   result.message,
            //   this.platform,
            //   this.toastCtl,
            //   3000,
            //   'bottom'
            // );
            this.goingToPay = false;
            this.onShowMessage('De-register', result.message);
            this.refreshPlayers();
            this.refreshCompData();
            this.getPlayerApplicableFee().then(() => {});
          });
        },
        error => {
          console.debug('error deregistering : ', error);
          let msg = MessageDisplayUtil.getErrorMessage(
            error,
            'Error de-registering from competition. Try again later.'
          );
          msg = 'Error de-registering from competition. Try again later.';
          if (error?.length) {
            msg = error;
            if (msg?.toLowerCase().includes('already done the payment')) {
              msg = 'You cannot deregister once payment has been made.';
            }
          }
          if (busy) {
            busy.dismiss();
          }
          // MessageDisplayUtil.showErrorToast(
          //   msg,
          //   this.platform,
          //   this.toastCtl,
          //   5000,
          //   'bottom'
          // );
          this.getPlayerApplicableFee().then(() => {});
          this.onErrorMessage('De-register', msg);
        }
      );
    });
  }

  /**
   * Refresh the competition details from the server
   * @param refresher
   */

  selectGameRound(roundNo) {
    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo, idx: number) => gr.roundNo == roundNo)
      .pop();
    return this.gameRound;
  }

  checkRoundInProgress() {
    if (this.competition.status == 'In Progress') {
      if (this.gameRound.roundNo == this.currentRound) {
        if (this.gameRound.status == 'InProgress') {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  checkRoundCompleted() {
    //let gameRound = this.selectGameRound(this.currentRound)

    if (this.competition.status == 'Completed') {
      return true;
    } else if (this.competition.status == 'In Progress') {
      if (this.gameRound && this.gameRound.status == 'Completed') {
        return true;
      }
    }
  }

  async onDescriptionClick() {
    const modal = await this.modalCtl.create({
      component: DescriptionModalPage,
      mode: 'ios',
      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        descriptionMenuActive: 'description',
        competition: this.competition,
        details: this.details,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async onRulesClick() {
    try {
      const modal = await this.modalCtl.create({
        component: DescriptionModalPage,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          competition: this.competition,
          compId: this.compId,
          descriptionMenuActive: 'rules',
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0]) {
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        }
      });
    } catch (error) {
      console.error('Error presenting rules modal:', error);
    }
  }

  async onCourseClick() {
    try {
      const modal = await this.modalCtl.create({
        component: DescriptionModalPage,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          competition: this.competition,
          compId: this.compId,
          descriptionMenuActive: 'courses',
          details: this.details.gameRounds,
          roundCourseRatings: this.compRoundCourseRatings,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0]) {
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        }
      });
    } catch (error) {
      console.error('Error presenting course modal:', error);
    }
  }

  private async getPlayerMembership(clubName: string) {
    let selectedClubName = '';
    const loader = await this.loadingCtl.create({
      showBackdrop: false,
    });
    loader.onDidDismiss().then((data: any) => {
      //

      if (data) {
        this.clubName = data.data
          .map(
            (membership: ClubMembership, idx: number) =>
              //return membership.homeClub
              (membership.club.clubName = clubName)
          )
          .pop();

        selectedClubName = this.clubName;
        //
        //
        //
        if (this.clubName == clubName) {
          this.register();
        } else {
          this.onClubRegisterClick(this.competition?.club?.id);
        }
      } else {
        return false;
      }
    });
    loader.present();
    this.playerService.getPlayerMemberships().subscribe(
      (memberships: Array<ClubMembership>) => {
        this.memberships = memberships;

        // this.clubIds = [];
        // memberships.forEach((m: ClubMembership) => {
        //     this.clubIds.push(m.club.clubId);
        // });
      },
      error => {
        const msg = MessageDisplayUtil.getErrorMessage(error);
        MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Membership', msg, 'OK');
        loader.dismiss(null);
      },
      () => {
        loader.dismiss(this.memberships);
      }
    );
  }

  prizeCount(): number {
    let prizeTotal = 0;

    if (this.details.prizes.length && this.details.teamPrizes.length) {
      prizeTotal = this.details.teamPrizes.length + this.details.prizes.length;
    } else if (this.details.teamPrizes.length) {
      prizeTotal = this.details.teamPrizes.length;
    } else if (this.details.prizes.length) {
      prizeTotal = prizeTotal = this.details.prizes.length;
    }

    return prizeTotal;
  }

  selectedRound(roundNo: number, fab: any) {
    this.currentRound = roundNo;
    //  this.roundInfo = this.getSelectedRoundInfo();
    //this.doRefresh(null);
    //+ this.roundInfo.id
    this.gameRound = this.details.gameRounds
      .filter((gr: GameRoundInfo) => gr.roundNo == this.currentRound)
      .pop();
    this.freshCompInfo = false;
    this._refreshCompetitionInfo(null);
    this.getCompMatches();
  }

  goPayment() {
    let playerInfo: PlayerInfo;
    const _compPlayer = this.details?.players?.filter(
      cp => cp?.playerId === this.session?.playerId
    )[0];

    this.playerService
      .getPlayerInfo(this.session.playerId)
      .subscribe(async (player: PlayerInfo) => {
        const modal = await this.modalCtl.create({
          component: CompetitionPaymentConfirm,
          componentProps: {
            details: this.details,
            competition: this.competition,
            compId: this.compId,
            player: player,
            compData: this.compData,
            compPlayerId: _compPlayer?.id,
          },
        });

        modal.onDidDismiss().then((data: any) => {
          if (data) {
            if (data.paid.toLowerCase() === 'paid' && data.success) {
              this.register();
            }
          }
        });
        modal.present();
      });

    // modal.onDidDismiss((data: any) => {

    //     if (data) {

    //         if(data.type === 'testCall') {
    //             // this.testCall();
    //         } else if(data.type === 'getRemoteCollections') {
    //             this.getRemoteCollections(data.collectionId);
    //         }else if(data.type === 'getLocalCollections') {
    //             this.getLocalCollections(data.collectionId);
    //         } else if(data.type === 'getBill') {
    //             this.getBill(data.billId);
    //         } else if(data.type === 'createBill') {
    //             this.createBill(data.collectionId);
    //         } else if(data.type === 'createRemoteBill') {
    //             this.createRemoteBill(data.collectionId);
    //         }
    //         // this.scorecard = data.scorecard
    //         // this._onCurrentHoleChange();
    //     }
    // });
  }

  private async preparePaymentData(maxRetries: number = 2) {
    try {
      // Show loading indicator
      const loading = await this.loadingCtl.create({
        message: 'Preparing payment...',
        backdropDismiss: false,
      });
      await loading.present();

      let _compPlayer = this.playerViews?.filter(
        cp => cp?.player?.id === this.session?.playerId
      )[0];

      let _playerInfo = await this.player$.pipe(take(1)).toPromise();

      // Retry logic if data is missing
      let retryCount = 0;

      while ((!_compPlayer || !_playerInfo) && retryCount < maxRetries) {
        retryCount++;
        loading.message = `Preparing payment... (Attempt ${retryCount + 1}/${maxRetries + 1})`;

        // Refresh data if missing
        if (!_compPlayer) {
          await this.getRegisteredPlayerViews();
          _compPlayer = this.playerViews?.filter(
            cp => cp?.player?.id === this.session?.playerId
          )[0];
        }

        if (!_playerInfo) {
          this.player$ = this.playerHomeInfo$
            .pipe(filter(Boolean))
            .pipe(map((playerHome: any) => playerHome));
          _playerInfo = await this.player$.pipe(take(1)).toPromise();
        }

        // Add a small delay between retries
        if (retryCount < maxRetries && (!_compPlayer || !_playerInfo)) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }

      // if (1) {
      //   _compPlayer = null;
      //   _playerInfo = null;
      // }

      // Validate both values after retries
      if (!_compPlayer) {
        await loading.dismiss();
        throw new Error('Player competition information not found after multiple attempts');
      }

      if (!_playerInfo) {
        await loading.dismiss();
        throw new Error('Player information not found after multiple attempts');
      }

      await loading.dismiss();

      return {
        compPlayer: _compPlayer,
        playerInfo: _playerInfo,
      };
    } catch (error) {
      console.error('Error preparing payment data:', error);
      throw error;
    }
  }

  async openPaymentSelection() {
    if (this.getPaymentStatus() === 'Full' || this.getPaymentStatus() === 'Nothing') {
      return;
    }
    if (this.isWaitListed()) {
      const _title = 'Payment halted';
      const _message =
        'You are waitlisted, you may proceed payment once Slots available/Registered';
      this.goDisplayMessage(_title, _message);
      this.goingToPay = false;
      return;
    }

    try {
      // // Add this test random logic BEFORE preparePaymentData
      // let _random = Math.floor(Math.random() * 2);
      // MessageDisplayUtil.showMessageToast(
      //   `Random test value: ${_random}`,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'top'
      // );

      // if (_random === 1) {
      //   // Force the error condition by clearing the data
      //   this.playerViews = [];
      //   this.player$ = of(null); // Set observable to emit null
      //   MessageDisplayUtil.showMessageToast(
      //     'Simulating missing data - retry should trigger',
      //     this.platform,
      //     this.toastCtl,
      //     5000,
      //     'top'
      //   );
      // }

      const { compPlayer: _compPlayer, playerInfo: _playerInfo } = await this.preparePaymentData();

      // if (!_compPlayer || !_playerInfo?.playerId) {
      //   MessageDisplayUtil.showErrorToast(
      //     "We couldn't find your competition registration details. This might be due to a connection issue. Please check your internet connection and try again.",
      //     this.platform,
      //     this.toastCtl,
      //     5000,
      //     'bottom'
      //   );
      //   // let { compPlayer: _compPlayer, playerInfo: _playerInfo } = await this.preparePaymentData();
      //   return;
      // }
      console.debug('opening payment selection ', _compPlayer, this.playerViews, _playerInfo);
      const modal = await this.modalCtl.create({
        component: CompetitionPaymentSelectionPage,
        cssClass: 'full-screen-modal',
        componentProps: {
          competitionDetails: this.details,
          compData: this.compData,
          competitionFeeApplicable: this.currentFeeApplicable,
          compPlayerId: _compPlayer?.id,
          playerId: this.session?.playerId,
          playerInfo: _playerInfo,
        },
        mode: 'ios',
      });

      modal.onDidDismiss().then(async data => {
        this.onRefreshClick(null);
      });
      await modal.present();
    } catch (error) {
      console.error('Error opening payment selection:', error);

      MessageDisplayUtil.showErrorToast(
        "We couldn't find your competition registration details. This might be due to a connection issue. Please check your internet connection and try again.",
        this.platform,
        this.toastCtl,
        5000,
        'bottom'
      );
      // this.onErrorMessage(
      //   'Error',
      //   'An error occurred while preparing payment. Please refresh and try again.'
      // );
    }
  }

  getTestCallAPI() {
    this.compService.testAPIcall().subscribe(data => {});
  }
  getPlayerStatus() {
    if (!this.flights) {
      return false;
    }
    if (!this.player$) {
      return false;
    }
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _playerInFlight: FlightMoreData; //Array<FlightInfo>;
    let _playerStatus: any; //Array<FlightMember>;

    this.flights
      .filter(
        (flight: FlightMoreData) => flight.playerFlight
        // _playerInFlight = flight.flightMembers.filter((flightMember)=>{
        //   return flightMember.playerId === _player.playerId
        // })
      )
      .map((flight: FlightMoreData) => {
        _playerInFlight = flight;
      });
    if (_playerInFlight && _playerInFlight.flightMembers.length > 0) {
      _playerInFlight.flightMembers
        .filter((member: any) => member.playerId === _player.playerId)
        .map((member: any) => {
          _playerStatus = member;
        });

      if (_playerStatus) {
        return _playerStatus.status;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  goLeagueScorecardOld() {
    const navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        leaderboards: this.leaderBoard,
        leaderboardPlayers: this.leaderBoard.players,
        roundNo: this.currentRound,
        categories: this.details.categories,
        teams: this.competition.teamEvent ? null : null,
        showTeam: this.showTeam,
      },
    };
    // this.router.navigate(['competition-players'], navigationExtras);
    // this.nav.push(LeagueLeaderboardPage)
  }

  goLeagueLeaderboardOld() {
    const navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        leaderboards: this.leaderBoard,
        leaderboardPlayers: this.leaderBoard.players,
        roundNo: this.currentRound,
        categories: this.details.categories,
        teams: this.competition.teamEvent ? null : null,
        showTeam: this.showTeam,
      },
    };
    // this.router.navigate(['competition-players'], navigationExtras);
    // this.nav.push(LeagueLeaderboardPage)
  }

  async isCompetitionEclectic() {
    console.debug('is competition eclectic', this.compData);
    if (!this.compData) {
      return;
    }
    this.isEclectic = this.compData?.leagueSeasons?.some((ls: LeagueSeason) => {
      if (ls?.natureOfLeague === 'League') {
        this.compSeasonId = ls?.id;
        return true;
      } else {
        return false;
      }
    });
    return this.isEclectic;
  }

  leagueTypes: Array<LeagueNature> = null;
  async parseLeagueType() {
    if (!this.compData) {
      return;
    }
    this.leagueTypes = this.compData?.leagueSeasons?.map((ls: LeagueSeason) => ls?.natureOfLeague);
    // .find((ls: LeagueSeason) => {
    //   if (ls?.natureOfLeague === 'League') {
    //     return ls?.natureOfLeague;
    //   } else return ls?.natureOfLeague;
    // }); //.map((ls)=> ls.natureOfLeague);
  }

  isLeagueType(type: LeagueNature) {
    return this.leagueTypes?.find((ls: LeagueNature) => ls === type);
  }

  goLeagueMenuOld() {
    const navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
      },
    };
    this.router.navigate(['tabs/competition-league-menu'], navigationExtras);
  }

  async goLeagueMenu() {
    if (1) {
      // if(this.compData?.leagueSeasons?.length > 1) {

      if (this.isEclectic) {
        const navigationExtras: NavigationExtras = {
          state: {
            leagueSeasons: this.compData.leagueSeasons,
            competition: this.competition,
            compSeasonId: this.compSeasonId,
          },
        };
        this.router.navigate(['tabs/competition-league-menu'], navigationExtras);
      } else {
        let leagueSeason = this.compData?.leagueSeasons[0];
        console.debug('going to leaderboard', this.compData, leagueSeason);
        if (leagueSeason?.status == 'Created') {
          this.onErrorMessage(
            '',
            'Competition has not started. Please refresh to view latest competition status.'
          );
          return false;
        }

        const _organizerId = this.compData?.organizer?.id || leagueSeason?.league?.organizer?.id;
        Promise.all([
          this.multiCourseCompService.refreshCompetitionDetails(_organizerId, leagueSeason?.id),
          this.multiCourseCompService
            .getMultiCourseDetails()
            .subscribe((compData: LeagueSeason) => {
              leagueSeason = compData;
            }),
          // this.flightService
          //   .getMultiCourseDetails(leagueSeason?.league?.organizer?.id, leagueSeason?.id)
          //   .subscribe((compData: LeagueSeason) => {
          //     leagueSeason = compData;
          //     this.multiCourseCompService.refreshLeaderboard(leagueSeason?.id, {
          //       scoreType: 'Gross',
          //     });
          //   }),
          // this.multiCourseCompService.setCurrentSeasonId(leagueSeason?.id),
          // this.multiCourseCompService.refreshSeasonDetails(),
        ]).then(() => {
          const navigationExtras: NavigationExtras = {
            state: {
              seasonId: leagueSeason?.id,
              leagueSeason: leagueSeason,
            },
          };
          this.router.navigate(['tabs/multi-course-competition-leaderboard'], navigationExtras);
        });
      }

      // const modal = await this.modalCtl.create({
      //   mode: 'ios',
      //   component: CompetitionLeagueMenuPage,
      //   cssClass: 'full-screen-modal', // 'self-adjustable-modal',
      //   componentProps: {
      //       app: null,
      //       mode: 'common',
      //       headerTitle: 'Competition League',
      //       leagueSeasons: this.compData.leagueSeasons,
      //       competition: this.competition,
      //       compSeasonId: this.compSeasonId,
      //   }
      // })
      // await modal.present().then(() => {
      //     const height = this.platform.height() - 250;
      //     if(document.getElementsByClassName('inner-content')[0])
      //     document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      // });
      // modal.onDidDismiss().then((data: any) => {
      //   console.debug("pullup dismiss", data)
      //   if(data) {
      //     if(data?.data?.id === 'leaderboard') {
      //       this.goLeagueLeaderboard();
      //     } else if(data?.data?.id === 'scorecards') {
      //       this.goLeagueScorecard();
      //     } else if(data?.data?.id === 'lowestAverage') {
      //       this.goLeagueLowestLeaderboard();
      //     }
      //   }
      //   // if(data)

      // })
      return;
    }
    const _dataList = [
      {
        id: 'leaderboard',
        name: 'Leaderboard',
        iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'scorecards',
        name: 'Scorecards',
        iconUrl: 'assets/icons/book.png',
      },
      {
        id: 'lowestAverage',
        name: 'Lowest Average',
        iconUrl: 'assets/icons/golf-field.png',
      },
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Competition League',
        subTitle: this.leagueRounds ? this.leagueRounds[0].seasonName : '',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'leaderboard') {
          this.goLeagueLeaderboard();
          // this.goEclecticLeaderboard();
        } else if (data?.data?.id === 'scorecards') {
          this.goLeagueScorecard();
        } else if (data?.data?.id === 'lowestAverage') {
          this.goLeagueLowestLeaderboard();
        }
      }
      // if(data)
    });
  }

  goLeagueScorecard() {
    const navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
      },
    };
    this.router.navigate(['tabs/competition-league-scorecard'], navigationExtras);
  }
  goLeagueLeaderboard() {
    const navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
        leagueType: 'Eclectic',
      },
    };
    this.router.navigate(['tabs/competition-league-leaderboard'], navigationExtras);
  }

  goLeagueLowestLeaderboard() {
    const navigationExtras: NavigationExtras = {
      state: {
        competition: this.competition,
        compId: this.compId,
        compSeasonId: this.compSeasonId,
      },
    };
    this.router.navigate(['tabs/competition-league-lowest'], navigationExtras);
  }

  compSeasonId: number;
  leagueRounds: Array<LeagueRound>;
  getLeagueSeason() {
    this.flightService.getLeagueSeason(this.compId).subscribe(data => {
      this.compSeasonId = data;
      this.getLeagueRounds(data);
      // this.refreshLeagueScorecards(this.compId);
    });
  }

  getLeagueRounds(seasonId: number) {
    this.flightService.getLeagueRounds(seasonId).subscribe(data => {
      if (data) {
        this.leagueRounds = data;
      }
    });
  }

  async moreDetailsTournament() {
    const modal = await this.modalCtl.create({
      component: DescriptionModalPage,
      showBackdrop: true,
      backdropDismiss: true,
      mode: 'ios',
      cssClass: 'self-adjustable-modal',
      componentProps: {
        descriptionMenuActive: 'moreDetails',
        totalRounds: this.competition?.totalRounds,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    await modal.onDidDismiss().then(data => {
      if (data?.data) {
        switch (data?.data) {
          case 'description':
            this.onDescriptionClick();
            break;
          case 'rules':
            this.onRulesClick();
            break;
          case 'courses':
            this.onCourseClick();
            break;
          case 'refresh':
            this.onRefreshClick(null);
            break;
          case 'changeRound':
            this.onClickRounds();
            break;
        }
      }
    });
  }

  async onClickRounds() {
    const _dataList = [];

    if (this.details?.gameRounds?.length > 0) {
      this.details.gameRounds.forEach(round => {
        _dataList.push({
          id: round.roundNo,
          name: 'Round ' + round.roundNo,
        });
      });
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'View Round',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id) {
          this.selectedRound(data.data.id, null);
        }
      }
      // if(data)
    });
  }

  compRoundCourseRatings: Array<CompetitionRoundCourseRatings> = [];
  getCompRoundCourseRatings() {
    const _compId = this.compId;
    this.flightService
      .getCompetitionCourseSlopeRatings(_compId, false)
      .subscribe((courseRatings: Array<CompetitionRoundCourseRatings>) => {
        this.compRoundCourseRatings = courseRatings;
      });
  }

  async onShowMessage(subtitle: string, body: string) {
    try {
      const _message = {
        subtitle: subtitle,
        body: body,
      };
      const modal = await this.modalCtl.create({
        component: DescriptionModalPage,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal'
          : 'self-adjustable-modal-desktop',
        componentProps: {
          message: _message,
          descriptionMenuActive: 'message',
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0]) {
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        }
      });
    } catch (error) {
      console.error('Error presenting message modal:', error);
    }
  }

  async onErrorMessage(subtitle: string, body: string) {
    try {
      const _message = {
        subtitle: subtitle,
        body: body,
      };
      console.debug('on error message : ', subtitle, body, _message);
      const modal = await this.modalCtl.create({
        component: DescriptionModalPage,
        mode: 'ios',
        cssClass: this.platform.is('mobile')
          ? 'self-adjustable-modal '
          : 'self-adjustable-modal-desktop ',
        componentProps: {
          message: _message,
          descriptionMenuActive: 'message',
          isError: true,
        },
      });
      await modal.present().then(() => {
        const height = this.platform.height() - 250;
        if (document.getElementsByClassName('inner-content')[0]) {
          document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
        }
      });
    } catch (error) {
      console.error('Error presenting error message modal:', error);
    }
  }

  private _checkCompetitionSessions() {
    if (!this.compData) {
      return false;
    }
    const _hasSessions = this.compData.gameRounds.find(
      (round: GameRoundData) => round.roundNo === 1 && round.sessions?.length > 0
    );
    console.debug('comp session ', _hasSessions, this.compData);
    if (_hasSessions) {
      this.compSessions = _hasSessions.sessions;
      return true;
    } else {
      return false;
    }
  }

  async goRegisterJoinSession() {
    if (!this.compSessions) {
      return;
    }
    const _dataList = [];
    if (this.compSessions?.length > 0) {
      this.compSessions.forEach(session => {
        let _slotsLeft = 0;
        let _slotsTaken = 0;
        if (session.sessionPlayers?.length > 0) {
          _slotsTaken = session.sessionPlayers.length;
        }
        _slotsLeft = session.maxSlots - _slotsTaken;
        if (session.allowJoinSession) {
          _dataList.push({
            id: session.sessionId,
            name:
              moment(session.startTime, 'HH:mm:ss').format('hh:mm A') +
              ' ( ' +
              (_slotsLeft + ' / ' + session.maxSlots) +
              ' slots )',
            disabled: _slotsLeft > 0 ? false : true,
          });
        }
      });
    }
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'singleSelection', //'common',
        headerTitle: 'Multi-Sessions Competition',
        subTitle: 'Choose available session to join',
        firstBtnTxt: 'Join',
        secondBtnTxt: 'Cancel',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        this.register(false, data.data.id);
      }
      // if(data)
    });
  }

  refreshPromiseCompData() {
    return new Promise((resolve, reject) => {
      this.refreshCompData();
      setTimeout(() => {
        resolve(true);
      }, 500);
    });
  }

  subCompDetails: Subscription;
  refreshCompData() {
    if (this.subCompDetails) {
      return;
    }
    const _compId = this.compId || this.compData?.id;
    this.subCompDetails = this.flightService.getCompetitionDetails(_compId).subscribe(
      (compData: CompetitionData) => {
        if (compData) {
          this.compData = compData;
          // this.getRegisteredPlayers();
          this.getRegisteredPlayerViews();
          this.getCompSponsorsList();
          this.getCompWaitList();
          this.compId = this.compData?.id;
          this.compService.setCompData(compData);
          this.getCompContentsList();

          this.getCompRoundCourseRatings();
          this.refreshFlightsList();
          this.setOutstandingAmount();
          //Get the scoring round
          this.compService.getScoringRoundNumber(this.compId).subscribe(
            (roundNo: number) => {
              this.scoringRound = roundNo;
              //Get players
              // this.compService.getPlayersRegistered(this.compId).subscribe(
              //   (players: any) => {
              //     this.details.players = players;
              //     let _player;
              //     this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
              //       if (player) _player = player;
              //     });

              //     this.playerIsPlaying = this.details.players.filter(
              //       (compPlayer: CompetitionPlayerInfo) => {
              //         if (compPlayer && compPlayer.playerId && _player && _player.playerId) {
              //           return compPlayer.playerId === _player.playerId;
              //         } else return false;
              //       }
              //     );

              //     // this.competition.totalRegistered = this.details.players.length;
              //     // this.refreshCompetitionTeams(loader, refresher, attribute);
              //   },
              //   error => {
              //     //Error getting comp players
              //       this._onRefreshComplete();
              //   }
              // );
            },
            error => {
              //Error getting scoring round
              this.scoringRound = 0;
              this._onRefreshComplete();
            }
          );
          if (this.isCompetitionEclectic()) {
            // this.getLeagueSeason();
            this.getLeagueRounds(this.compSeasonId);
          }
          this.parseLeagueType();
          if (compData?.matchPlay) {
            this.getCompMatches();
            this.getCompTeamPlayers();
          }
          this._checkCompetitionSessions();
          this.getCompetitionAdditionalInfo();
          this.getCompPlayerAdditionalInfo();
          this.getPlayerDetails();
          // this.goingToPay = false;
          this.getPlayerApplicableFee().then(() => {});
        }
        console.debug('get comp data', compData, this.compData);
        if (this.subCompDetails) {
          this.subCompDetails.unsubscribe();
          this.subCompDetails = null;
        }
      },
      error => {
        if (this.subCompDetails) {
          this.subCompDetails.unsubscribe();
          this.subCompDetails = null;
        }
      },
      () => {}
    );
  }

  getRoundStatus() {
    // if(!this.compData) return '';
    if (!this.currentRound) {
      return '';
    }
    // console.debug(" get round status : ", this.compData?.status, this.currentRound)
    if (
      this.compData &&
      (this.compData?.status === 'Completed' ||
        this.compData?.status === 'Cancelled' ||
        this.compData?.status === 'Upcoming')
    ) {
      return this.compData.status;
    } else if (!this.compData && this.competition?.status) {
      return this.competition.status;
    } else {
      if (this.compData?.gameRounds?.length === 1) {
        return this.compData.status;
      } else {
        const _roundStatus = this.compData?.gameRounds.find(
          round =>
            // console.debug(" get round status : ", round)
            round.roundNo === this.currentRound
        );
        return this.mg2uUtils.separateWords(_roundStatus.status);
      }
    }
  }

  getClassStatus() {
    if (this.getRoundStatus().toLowerCase().includes('in progress')) {
      return 'inProgress';
    } else if (this.getRoundStatus().toLowerCase().includes('completed')) {
      return 'completed';
    } else if (this.getRoundStatus().toLowerCase().includes('elapsed')) {
      return 'upComing';
    } else if (this.getRoundStatus().toLowerCase().includes('upcoming')) {
      return 'upComing';
    } else if (this.getRoundStatus().toLowerCase().includes('pending')) {
      return 'upComing';
    } else if (this.getRoundStatus().toLowerCase().includes('cancelled')) {
      return 'cancelled';
    }
    // {'inProgress' : getRoundStatus().toLowerCase().includes('in progress') ,
    //                             'completed': getRoundStatus().toLowerCase().includes('completed')  ,
    //                             'upComing': getRoundStatus().toLowerCase().includes('elapsed') ,
    //                             'upComing': getRoundStatus().toLowerCase().includes('upcoming'),
    //                             'upComing': getRoundStatus().toLowerCase().includes('pending'),
    //                             'cancelled': getRoundStatus().toLowerCase().includes('cancelled')}
  }

  getRegisterText() {
    let _text = 'Register Now';
    if (this.isWaitListed()) {
      _text = 'Already Wait Listed';
      return _text;
    }
    if (this.compData?.waitListSize > 0) {
      if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
        if (this.getTotalWaitList() < this.compData.waitListSize) {
          _text = 'Join Waitlist';
        }
      }
    }
    return _text;
  }

  getDeregisterText() {
    let _text = 'Deregister';
    if (this.isWaitListed()) {
      _text = 'Remove from wait list';
    }
    return _text;
  }

  isRegistered() {
    if (!this.compData) {
      return;
    }
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
      // console.debug("current player ", player)
    });
    let _isRegistered = false;
    if (this.playerViews?.length > 0) {
      if (
        this.playerViews.find(
          (cp: CompetitionPlayerFullView) =>
            (cp?.player?.id === _player?.playerId || cp?.player?.id === _player?.id) &&
            cp?.status === 'Registered'
        )
      ) {
        _isRegistered = true;
      }
    }
    // console.debug('is registered : ', _player, this.playerViews, _isRegistered);

    return _isRegistered;
  }

  isWaitListed() {
    if (!this.compData) {
      return;
    }
    if (this.compData?.waitListSize === 0) {
      return false;
    }
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
      // console.debug('current player ', player);
    });
    let _isWaitListed = false;
    // console.debug('is wait listed : ', _player, this.compData?.waitListSize, this.compWaitList);
    if (this.compWaitList?.length > 0) {
      if (
        this.compWaitList.find(
          (wl: CompetitionWaitList) =>
            (wl?.player?.id === _player?.playerId || wl?.player?.id === _player?.id) &&
            wl?.status === 'WaitListed'
        )
      ) {
        _isWaitListed = true;
      }
    }
    return _isWaitListed;
  }

  getTotalWaitList(status?: string) {
    if (!this.compData) {
      return;
    }
    let _totalWaitListed = 0;
    if (this.compWaitList?.length > 0) {
      _totalWaitListed = this.compWaitList.filter((wl: CompetitionWaitList) => {
        if (status?.length > 0) {
          return wl.status === status;
        } else {
          return wl.status === 'WaitListed';
        }
      })?.length;
    }
    return _totalWaitListed;
  }

  getTotalRegistered() {
    if (!this.playerViews) {
      return;
    }
    let _totalRegistered = 0;

    if (this.playerViews.length > 0) {
      _totalRegistered = this.playerViews.filter(
        (cp: CompetitionPlayerFullView) => cp?.status === 'Registered'
      )?.length;
    }
    return _totalRegistered;
    // if (!this.compData) return;
    // let _totalRegistered = 0;
    // // if(this.registeredPlayers) {

    // // }
    // if (this.playerViews?.length > 0) {
    //   _totalRegistered = this.compData.players.filter((cp: CompetitionPlayerData) => {
    //     return cp?.status === 'Registered';
    //   })?.length;
    // }
    // return _totalRegistered;
  }

  async removeFromWaitList() {
    const register = await this.loadingCtl.create({
      showBackdrop: false,
      message: 'Removing...',
    });

    register.present().then(() => {
      this.flightService.compCancelWaitlist(this.compId, this.session.playerId).subscribe(
        (result: ServerResult) => {
          console.debug('registering to  : ', register);
          register.dismiss().then(() => {
            if (result.success || result) {
              // this.competition.registered = true;
              // MessageDisplayUtil.showMessageToast(
              //   result.message,
              //   this.platform,
              //   this.toastCtl,
              //   3000,
              //   'bottom'
              // );
              let _msg = 'You are successfully de-listed from Wait List.';
              if (result?.message) {
                _msg = result.message;
              }

              this.onShowMessage('De-listed', _msg);
              this.refreshPlayers();
              this.refreshCompData();
            } else {
              this._conditionalRegister(result.message);
            }
          });
        },
        error => {
          register.dismiss().then(() => {
            let _modifiedMsg: string;
            const msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error occured while de-listing from Wait List. Try again later.'
            );
            if (error?.length > 0 && error?.toLowerCase().includes('already registered')) {
              _modifiedMsg = this.mg2uUtils.wrapReplaceNextWordAfter(error, 'competition', 'b');
            } else {
              _modifiedMsg = error;
            }
            // MessageDisplayUtil.showErrorToast(
            //   msg,
            //   this.platform,
            //   this.toastCtl,
            //   5000,
            //   'bottom'
            // );
            // 'Error occured while registering for this comptetition. Try again later.'
            this.onErrorMessage('Register', _modifiedMsg);
          });
        }
      );
    });
  }

  isClosedForRegistration() {
    /// old code
    // let _currDate = moment();
    // let _closeDate = moment(
    //   this.compData?.closeDate + ' ' + this.compData?.registrationCloseTime,
    //   'YYYY-MM-DD HH:mm:ss'
    // );

    // return _currDate.isAfter(_closeDate, 'minute');

    /// new code
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    const openDateTime = `${this.compData?.openDate}T${this.compData?.registrationOpenTime}`;
    const closeDateTime = `${this.compData?.closeDate}T${this.compData?.registrationCloseTime}`;
    const openTime = DateTime.fromISO(openDateTime, { zone: clubTimeZone });
    const closeTime = DateTime.fromISO(closeDateTime, { zone: clubTimeZone });
    const currTime = DateTime.now(); // DateTime.fromISO('2025-06-04T02:00:00', { zone: 'UTC' });
    // console.debug(
    //   'closed for registration ',
    //   clubTimeZone,
    //   openDateTime,
    //   closeDateTime,
    //   'open time : ',
    //   openTime.toUTC().toISO(),
    //   'close time : ',
    //   closeTime.toUTC().toISO(),
    //   'is closed? : ',
    //   closeTime.toUTC() <= currTime.toUTC(),
    //   'current time : ',
    //   currTime.toUTC().toISO()
    // );
    return !(openTime.toUTC() <= currTime.toUTC() && closeTime.toUTC() >= currTime.toUTC());
    // return closeTime.toUTC() <= currTime.toUTC();
  }
  isNotOpenForRegistration() {
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    const openDateTime = `${this.compData?.openDate}T${this.compData?.registrationOpenTime}`;
    const closeDateTime = `${this.compData?.closeDate}T${this.compData?.registrationCloseTime}`;
    const openTime = DateTime.fromISO(openDateTime, { zone: clubTimeZone });
    const closeTime = DateTime.fromISO(closeDateTime, { zone: clubTimeZone });
    const currTime = DateTime.now();
    return openTime.toUTC() > currTime.toUTC();
  }

  getRegistrationClose(useFormat: boolean = false) {
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    const closeDateTime = `${this.compData?.closeDate}T${this.compData?.registrationCloseTime}`;
    const closeTime = DateTime.fromISO(closeDateTime, { zone: clubTimeZone });
    const day = closeTime.day;
    const ordinal = this.mg2uUtils.getOrdinalSuffix(day);

    if (useFormat) {
      return closeTime.toFormat(`EEE, dd MMM hh:mm a`);
    }
    return closeTime;
  }

  getRegistrationOpen(useFormat: boolean = false) {
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    const openDateTime = `${this.compData?.openDate}T${this.compData?.registrationOpenTime}`;
    const openTime = DateTime.fromISO(openDateTime, { zone: clubTimeZone });
    const day = openTime.day;
    const ordinal = this.mg2uUtils.getOrdinalSuffix(day);

    if (useFormat) {
      return openTime.toFormat(`EEE, dd MMM hh:mm a`);
    }
    return openTime;
  }

  getCompImage() {
    // console.debug("get club image [0] : ", this.clubMembership)
    if (!this.compData) {
      return 'assets/image/default/default_competition.jpg';
    }
    let _compImage = '';
    if (this.compData.image) {
      _compImage = this.compData?.image;
    } else if (this.compData?.thumbnail) {
      _compImage = this.compData?.thumbnail;
    } else {
      return 'assets/image/default/default_competition.jpg';
    }

    // console.debug("get club image [1] : ", _clubImage)
    if (_compImage.toLowerCase().includes(global.MygolfServerHost.toLowerCase())) {
      return _compImage;
    } else {
      return global.MygolfServer + '/' + _compImage;
    }
  }

  parseTime(time: string, format?: string) {
    if (!!format) {
      return moment(time, 'HH:mm:ss').format(format);
    } else {
      return moment(time, 'HH:mm:ss').format('hh:mm A');
    }
  }

  getCompFee() {
    if (!this.compData) {
      return;
    }

    const _compPlayer = this.playerViews?.filter(
      cp => cp?.player?.id === this.session?.playerId
    )[0];

    let _amounTtxt = '';
    const _currency = this.compData?.currency?.symbol || this.currentFeeApplicable?.currencySymbol;

    if (this.getPaymentStatus() === 'Full') {
      const _tournamentFee = this.compData?.tournamentFee;
      const _orgMemberFee = this.compData?.tournamentFeeOrgMember;
      const _clubMemberFee = this.compData?.tournamentFeeClubMember;

      const _applicableFee = this.currentFeeApplicable?.applicableFee || 0;
      _amounTtxt = `${_currency} ${_applicableFee}`;
      if (
        this.currentFeeApplicable?.feeType === 'Standard' ||
        this.currentFeeApplicable?.feeType === 'Auto'
      ) {
        if (_applicableFee !== _tournamentFee) {
          _amounTtxt = `${_currency} ${_tournamentFee}`;
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('club')) {
        if (_applicableFee !== _clubMemberFee) {
          _amounTtxt = `${_currency} ${_clubMemberFee}`;
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('organizer')) {
        if (_applicableFee !== _orgMemberFee) {
          _amounTtxt = `${_currency} ${_orgMemberFee}`;
        }
      } else {
        if (_applicableFee !== _tournamentFee) {
          _amounTtxt = `${_currency} ${_tournamentFee}`;
        } else {
          if (_compPlayer?.feePayable) {
            _amounTtxt = _currency + ' ' + this.mg2uUtils.numberWithCommas(_compPlayer?.feePayable);
          } else if (this.currentFeeApplicable) {
            _amounTtxt =
              _currency +
              ' ' +
              this.mg2uUtils.numberWithCommas(this.currentFeeApplicable?.applicableFee);
          }
          // this.currentFeeApplicable?.applicableFee;
          else {
            _amounTtxt =
              _currency + ' ' + this.mg2uUtils.numberWithCommas(this.compData?.tournamentFee);
          }
        }
      }
    } else {
      const _tournamentFee = this.compData?.tournamentFee;
      const _orgMemberFee = this.compData?.tournamentFeeOrgMember;
      const _clubMemberFee = this.compData?.tournamentFeeClubMember;

      const _applicableFee = this.currentFeeApplicable?.applicableFee || 0;
      _amounTtxt = `${_currency} ${_applicableFee}`;
      // console.debug(
      //   'get comp fee : ',
      //   this.currentFeeApplicable,
      //   _tournamentFee,
      //   _orgMemberFee,
      //   _clubMemberFee,
      //   _applicableFee,
      //   _amounTtxt
      // );
      if (
        this.currentFeeApplicable?.feeType === 'Standard' ||
        this.currentFeeApplicable?.feeType === 'Auto'
      ) {
        if (_applicableFee !== _tournamentFee) {
          _amounTtxt = `${_currency} ${_tournamentFee}`;
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('club')) {
        if (_applicableFee !== _clubMemberFee) {
          _amounTtxt = `${_currency} ${_clubMemberFee}`;
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('organizer')) {
        if (_applicableFee !== _orgMemberFee) {
          _amounTtxt = `${_currency} ${_orgMemberFee}`;
        }
      } else {
        if (_applicableFee !== _tournamentFee) {
          _amounTtxt = `${_currency} ${_tournamentFee}`;
        } else {
          if (_compPlayer?.feePayable) {
            _amounTtxt = _currency + ' ' + this.mg2uUtils.numberWithCommas(_compPlayer?.feePayable);
          } else if (this.currentFeeApplicable) {
            _amounTtxt =
              _currency +
              ' ' +
              this.mg2uUtils.numberWithCommas(this.currentFeeApplicable?.applicableFee);
          }
          // this.currentFeeApplicable?.applicableFee;
          else {
            _amounTtxt =
              _currency + ' ' + this.mg2uUtils.numberWithCommas(this.compData?.tournamentFee);
          }
        }
      }
      // if (_compPlayer?.feePayable) {
      //   _amounTtxt = _currency + ' ' + this.mg2uUtils.numberWithCommas(_compPlayer?.feePayable);
      // } else if (this.currentFeeApplicable) {
      //   _amounTtxt =
      //     _currency +
      //     ' ' +
      //     this.mg2uUtils.numberWithCommas(this.currentFeeApplicable?.applicableFee);
      // }
      // // this.currentFeeApplicable?.applicableFee;
      // else {
      //   _amounTtxt =
      //     _currency + ' ' + this.mg2uUtils.numberWithCommas(this.compData?.tournamentFee);
      // }
    }

    return _amounTtxt;
  }

  getPaidFee() {
    if (!this.compData) {
      return;
    }
    if (this.currentFeeApplicable?.paymentStatus === 'Unpaid') {
      return;
    }
    let _amounTtxt = '';
    const _currency = this.compData?.currency?.symbol || this.currentFeeApplicable?.currencySymbol;
    if (this.currentFeeApplicable?.paymentStatus === 'Full') {
      return `${_currency} ${this.currentFeeApplicable?.paymentAmount}`;
    }
    const _compPlayer = this.playerViews?.filter(
      cp => cp?.player?.id === this.session?.playerId
    )[0];

    if (_compPlayer?.feePayable) {
      _amounTtxt = _currency + ' ' + this.mg2uUtils.numberWithCommas(_compPlayer?.feePayable);
    } else if (this.currentFeeApplicable) {
      _amounTtxt =
        _currency + ' ' + this.mg2uUtils.numberWithCommas(this.currentFeeApplicable?.applicableFee);
    }
    // this.currentFeeApplicable?.applicableFee;
    else {
      _amounTtxt = _currency + ' ' + this.mg2uUtils.numberWithCommas(this.compData?.tournamentFee);
    }
    return _amounTtxt;
  }

  needPayment() {
    if (!this.compData) {
      return;
    }
    return this.compData?.paymentMandatory;
  }

  classPaymentColor() {
    if (!this.currentFeeApplicable) {
      return '';
    }
    switch (this.getPaymentStatus() || this.currentFeeApplicable?.paymentStatus) {
      case 'Unpaid':
        return 'unpaid';
      case 'Partial':
        return 'partially-paid';
      case 'Full':
        return 'fully-paid';
      case 'Nothing':
        return 'fully-paid';
      default:
        return 'unpaid';
    }
  }

  getPaymentStatus() {
    if (!this.currentFeeApplicable) {
      return;
    }
    if (
      this.currentFeeApplicable?.paymentStatus !== 'Full' &&
      this.currentFeeApplicable?.applicableFee === 0
    ) {
      return 'Nothing';
    }
    if (
      this.currentFeeApplicable?.paymentStatus === 'Full' &&
      this.currentFeeApplicable?.applicableFee === 0
    ) {
      return 'Nothing';
    }
    const _paymentStatus = this.playerViews?.filter(
      cp => cp?.player?.id === this.session?.playerId
    )[0]?.paymentStatus;
    return _paymentStatus || this.currentFeeApplicable?.paymentStatus;
  }

  getDerivedPaymentStatus(paymentStatus: string) {
    const _paymentStatus = paymentStatus?.toLowerCase();
    switch (_paymentStatus) {
      case 'full':
        return 'Fully Paid';
      case 'unpaid':
        return 'Pending Payment';
      case 'partial':
        return 'Partially Paid';
      case 'nothing':
        return 'Nothing to Pay';
    }
  }

  goingToPay = false;
  currentFeeApplicable: CompetitionFeeApplicable;
  getPlayerApplicableFee() {
    return new Promise((resolve, reject) => {
      if (!this.compData) {
        return;
      }
      const _playerIds = [];
      if (this.session?.playerId) {
        _playerIds.push(this.session?.playerId);
      }

      // this.player$.pipe(take(1)).subscribe((player) => {
      //   _playerIds.push(player?.playerId | player?.id)
      // });
      console.debug(
        'get player applicable fee',
        this.session,
        _playerIds,
        this.player$,
        this.goingToPay,
        this.isRegistered(),
        this.isWaitListed()
      );
      if (this.goingToPay || this.isRegistered()) {
        this.flightService
          .getCompApplicableFee(this.compData?.id, _playerIds, this.goingToPay)
          .subscribe(
            (data: Array<CompetitionFeeApplicable>) => {
              if (data) {
                this.currentFeeApplicable = data?.filter(
                  (cfa: CompetitionFeeApplicable) => cfa?.player?.playerId === _playerIds[0]
                )[0];
                console.debug(
                  'get player applicable fee',
                  this.session,
                  this.currentFeeApplicable,
                  data
                );
                resolve(data);
              }
              this.setOutstandingAmount();
            },
            error => {
              reject(error);
            },
            () => {
              // resolve(true)
            }
          );
      } else {
        this.flightService.getCompEstimatedFee(this.compData?.id, _playerIds[0]).subscribe(
          (data: CompetitionFeeApplicable) => {
            if (data) {
              this.currentFeeApplicable = data;

              console.debug(
                'get player estimated fee',
                this.session,
                this.currentFeeApplicable,
                data
              );
              resolve(data);
            }
            this.setOutstandingAmount();
          },
          error => {
            reject(error);
          },
          () => {
            // resolve(true)
          }
        );
      }
    });
  }
  outstandingAmount = 0;

  paymentClicked = false;

  isJoiningWaitlist() {
    return (
      !this.isWaitListed() &&
      !this.isRegistered() &&
      this.compData?.waitListSize > 0 &&
      this.getTotalRegistered() >= this.compData?.maxPlayers &&
      this.getTotalWaitList() < this.compData.waitListSize
    );
  }
  async goPaymentInfo() {
    this.goingToPay = false;
    // await this.refreshCompData();
    if (this.paymentClicked) {
      return;
    }

    const joiningWaitList = this.isJoiningWaitlist();
    if (joiningWaitList) {
      this.onRegisterClick();
      return;
    }
    this.paymentClicked = true;
    this.refreshPromiseCompData().then((result: any) => {
      if (this.isClosedForRegistration() && this.compData?.paymentMandatory) {
        this.paymentClicked = false;
        let _message = 'Registration has been closed';
        if (this.isNotOpenForRegistration()) {
          _message = 'Registration has not yet opened';
        }
        MessageDisplayUtil.showErrorToast(_message, this.platform, this.toastCtl, 5000, 'bottom');
        return;
      } else {
        this.paymentClicked = false;
      }
      this.getPlayerApplicableFee()
        .then((result: any) => {
          if (result) {
            if (this.isWaitListed()) {
              this.openPaymentInfo(true);
              return;
            }
            if (!this.compData?.paymentMandatory) {
              this.openPaymentInfo();
            } else if (
              this.getPaymentStatus() === 'Full' ||
              this.getPaymentStatus() === 'Nothing'
            ) {
              this.openPaymentInfo();
            } else {
              this.openPaymentInfo();
            }
          }
        })
        .catch(error => {
          MessageDisplayUtil.showErrorToast(error, this.platform, this.toastCtl, 5000, 'bottom');
        });
    });
  }

  async openPaymentInfo(onlyPaymentInfo?: boolean) {
    this.paymentClicked = false;

    let _mode = 'compRegister';
    let _title = 'Register & Pay';
    let _firstBtnTxt = 'Register & Pay';
    const _secondBtnTxt = 'Register';
    const _paymentStatus = '';
    let _showSecondBtn = true;
    const _balance =
      this.currentFeeApplicable?.applicableFee - this.currentFeeApplicable?.paymentAmount;
    let _feeApplicable = '';
    let _extraCheckboxOption;
    const _currency = this.compData?.currency?.symbol || this.currentFeeApplicable?.currency;

    if (this.currentFeeApplicable) {
      _feeApplicable = `<br><br>The fee is <b>${this.currentFeeApplicable?.currencySymbol} ${_balance}</b>.`;
    }

    const _compPlayer = this.playerViews?.filter(
      cp => cp?.player?.id === this.session?.playerId
    )[0];
    const _needPayment =
      this.compData?.paymentMandatory &&
      (this.getPaymentStatus() === 'Unpaid' || this.getPaymentStatus() === 'Partial');

    const _closeDate = moment(
      this.compData?.closeDate + ' ' + this.compData?.registrationCloseTime,
      'YYYY-MM-DD HH:mm:ss'
    ).format('ddd, DD MMM YYYY hh:mm A');
    // let _content = `To secure your registration, <b>Pay Online</b> before <b>${_closeDate}</b>`;

    let _content = `To secure your registration, <b>Pay Online</b> <b>${this.getPaymentDueText()}</b>`;
    if (!this.compData?.cancelOnPaymentDefault) {
      _content += ` before ${_closeDate}`;
    }

    let _inputRequired = false;
    if (
      _compPlayer?.feeTypeSelected !== 'ClubMember' &&
      (!_compPlayer?.golfClubMembership || _compPlayer?.golfClubMembership?.length === 0) &&
      this.currentFeeApplicable?.feeType !== 'Club Member'
    ) {
      _extraCheckboxOption = {
        id: 'ClubMember',
        name: `I'm a Club Member`,
        checked: false,
      };
      _inputRequired = true;
    }
    // else if(_compPlayer?.feeTypeSelected !== 'OrganizerMember') {
    //   _extraCheckboxOption = {
    //     id: 'OrganizerMember',
    //     name: `I'm an Organizer Member`,
    //     checked: false,
    //   }
    // }

    const _tournamentFee = this.compData?.tournamentFee;
    const _orgMemberFee = this.compData?.tournamentFeeOrgMember;
    const _clubMemberFee = this.compData?.tournamentFeeClubMember;

    let _payableAmount = this.currentFeeApplicable?.applicableFee || 0;

    if (this.getPaymentStatus() === 'Unpaid') {
      if (this.currentFeeApplicable?.feeType === 'Standard') {
        if (this.currentFeeApplicable?.applicableFee < _tournamentFee) {
          _payableAmount = _tournamentFee;
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('club')) {
        if (this.currentFeeApplicable?.applicableFee < _clubMemberFee) {
          _payableAmount = _clubMemberFee;
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('organizer')) {
        if (this.currentFeeApplicable?.applicableFee < _orgMemberFee) {
          _payableAmount = _orgMemberFee;
        }
      } else {
        if (this.currentFeeApplicable?.applicableFee < _tournamentFee) {
          _payableAmount = _tournamentFee;
        }
      }
    }
    if (1) {
      _content += `<br><br>Non-Member <b>${_currency} ${_tournamentFee}</b>`;
      if (_orgMemberFee) {
        _content += `<br>Organizer Member <b>${_currency} ${_orgMemberFee}</b>`;
      }
      if (_clubMemberFee) {
        _content += `<br>Club Member <b>${_currency} ${_clubMemberFee}</b>`;
      }
    }
    if (onlyPaymentInfo) {
      _title = `Registration Fee`;
      _content = `Non-Member ${_currency} ${_tournamentFee}`;
      if (_orgMemberFee) {
        _content += `<br>Organizer Member ${_currency} ${_orgMemberFee}`;
      }
      if (_clubMemberFee) {
        _content += `<br>Club Member ${_currency} ${_clubMemberFee}`;
      }
      _content += `<br><br>Online payment is not available`;
      _mode = 'infoDisplay';
      _extraCheckboxOption = null;
    } else {
      if (this.isRegistered() && _needPayment) {
        _firstBtnTxt = 'Pay Now';
        _title = 'Payment Status';
        _showSecondBtn = false;
        _content = `To secure your registration, <b>Pay Online</b> <b>${this.getPaymentDueText()}</b>`;
        if (!this.compData?.cancelOnPaymentDefault) {
          _content += ` before ${_closeDate}`;
        }
        _content += `<br><br>Your payment status is <b>
        ${this.getDerivedPaymentStatus(this.getPaymentStatus())}</b>.
        <br><br>The fee is <b>${this.currentFeeApplicable?.currencySymbol} ${_payableAmount}</b>.
        <br><br>Tap <b>Pay Now</b> to make payment.`;

        _extraCheckboxOption = null;
        if (this.compAddInfoForm && this.getMissingInfoForm() > 0) {
          _firstBtnTxt = 'Update Missing Info';
          _title = 'Payment Status';
          _showSecondBtn = false;
          _content = `To secure your registration, <b>Pay Online</b> <b>${this.getPaymentDueText()}</b>`;
          if (!this.compData?.cancelOnPaymentDefault) {
            _content += ` before ${_closeDate}`;
          }
          _content += `<br><br>Your payment status is <b>${this.getDerivedPaymentStatus(this.getPaymentStatus())}</b>.<br><br>The fee is <b>${this.currentFeeApplicable?.currencySymbol} ${this.currentFeeApplicable?.applicableFee}</b>.<br><br>
          You cannot make payment if your information is incomplete.<br>
          Tap on <b>Missing Info</b> to complete the form.`;
        }
      } else if (!this.compData?.paymentMandatory) {
        _title = `Registration Fee`;
        _content = `Non-Member ${_currency} ${_tournamentFee}`;
        if (_orgMemberFee) {
          _content += `<br>Organizer Member ${_currency} ${_orgMemberFee}`;
        }
        if (_clubMemberFee) {
          _content += `<br>Club Member ${_currency} ${_clubMemberFee}`;
        }
        _content += `<br><br>Online payment is not available`;
        _mode = 'infoDisplay';
        _extraCheckboxOption = null;
      } else if (
        this.isRegistered() &&
        (this.getPaymentStatus() === 'Full' || this.getPaymentStatus() === 'Nothing')
      ) {
        _title = `Registration Fee`;
        // const _orgMemberFee = this.compData?.tournamentFeeOrgMember;
        // const _clubMemberFee = this.compData?.tournamentFeeClubMember;
        _content = `Non-Member ${_currency} ${_tournamentFee}`;
        if (_orgMemberFee) {
          _content += `<br>Organizer Member : ${_currency} ${_orgMemberFee}`;
        }
        if (_clubMemberFee) {
          _content += `<br>Club Member : ${_currency} ${_clubMemberFee}`;
        }
        _mode = 'infoDisplay';
        _extraCheckboxOption = null;
      }

      // if (this.compData?.waitListSize > 0) {
      //   if (this.getTotalRegistered() >= this.compData?.maxPlayers) {
      //     if (this.getTotalWaitList() < this.compData.waitListSize && !this.isWaitListed() && !this.isRegistered()) {
      //       _content += `<br><br>Are you sure you want to Join Wait List? B`;
      //     }
      //   }
      // }
    }

    if (this.compData?.tournamentFeeClubMember === null) {
      _extraCheckboxOption = null;
    }
    const _message = {
      title: _title,
      content: _content,
    };

    let _requireAndPast: boolean = false;
    const paymentDueDateTime = this.compData.paymentDueOn;
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    const paymentTime = DateTime.fromISO(paymentDueDateTime, { zone: clubTimeZone });
    const currTime = DateTime.now();

    if (this.compData?.cancelOnPaymentDefault && currTime.toUTC() >= paymentTime.toUTC()) {
      _requireAndPast = true;
    }

    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        mode: _mode,
        // headerTitle: 'View Round',
        message: _message,
        firstBtnTxt: _firstBtnTxt,
        firstBtnColor: 'secondary',
        secondBtnTxt: _requireAndPast ? '' : _secondBtnTxt,
        showConfirmBtn: _requireAndPast ? false : _showSecondBtn,
        extraCheckboxOption: _extraCheckboxOption,
        inputRequired: _inputRequired,
        competitionFeeApplicable: this.currentFeeApplicable,
        payableAmount: _payableAmount,
        competitionData: this.compData,
        membershipNo:
          this.currentFeeApplicable?.golfClubMembership || _compPlayer?.golfClubMembership,
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      if (document.getElementsByClassName('inner-content')[0]) {
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
      }
    });
    modal.onDidDismiss().then(async (data: any) => {
      console.debug('pullup dismiss', data);
      // data?.data?.membershipNo || data?.data?.extraCheckboxOption?.id
      if (data?.data) {
        const _feeTypeSelected = data?.data?.extraCheckboxOption?.checked
          ? data?.data?.extraCheckboxOption?.id
          : null;
        const _membershipNo = data?.data?.membershipNo;
        if (data?.data?.type === 2) {
          console.debug('register first');

          if (this.compAddInfoForm) {
            try {
              // const done = await this.goFillMissingInfo();
              // if (done) {
              this._newRegister(null, null, false, _feeTypeSelected, _membershipNo).then(
                async (result: any) => {
                  console.debug('_newRegister : ', result);
                  if (result?.result > 0) {
                    this.goFillMissingInfo();

                    let _toastMessage = result?.message;
                    MessageDisplayUtil.showMessageToast(
                      _toastMessage,
                      this.platform,
                      this.toastCtl,
                      10000,
                      'bottom',
                      'primary',
                      'stacked'
                    );
                    // this.onShowMessage(result?.title, result?.message);
                  }
                }
              );
              this.compService.setPlayerIsRegistered(true);
              // }
            } catch (error) {
              this.compService.setPlayerIsRegistered(true);
            }
          } else {
            this._newRegister(null, null, true, _feeTypeSelected, _membershipNo).then(
              (result: any) => {
                console.debug('_newRegister : ', result);
              }
            );
          }
        } else if (data?.data?.type === 1) {
          console.debug(
            'register and pay',
            this.isRegistered(),
            _needPayment,
            this.compData?.paymentUrl
          );
          if (this.isRegistered() && _needPayment) {
            this.goingToPay = true;
            if (this.compAddInfoForm && this.getMissingInfoForm() > 0) {
              const done = await this.goFillMissingInfo(this.goingToPay);
              if (done) {
                this.getPlayerApplicableFee().then((result: any) => {
                  if (result) {
                    if (this.currentFeeApplicable?.applicableFee === 0) {
                    } else {
                      this.openPaymentSelection();
                    }
                  }
                });
                this.compService.setPlayerIsRegistered(true);
              }
            } else {
              this.getPlayerApplicableFee().then((result: any) => {
                if (result) {
                  if (this.currentFeeApplicable?.applicableFee === 0) {
                  } else {
                    this.openPaymentSelection();
                  }
                }
              });
            }
          } else {
            this.goingToPay = true;
            if (this.compAddInfoForm) {
              // const done = await this.goFillMissingInfo(this.goingToPay);
              // if (done) {
              this._newRegister(null, null, false, _feeTypeSelected, _membershipNo).then(
                async (registered: any) => {
                  console.debug('_newRegister : ', registered);
                  if (registered < 0) return;
                  const done = await this.goFillMissingInfo(this.goingToPay);
                  if (done) {
                    const busy = await this.loadingCtl.create({
                      message: 'Redirecting to payment page...',
                      backdropDismiss: false,
                    });
                    busy.present().then(() => {
                      if (registered) {
                        setTimeout(() => {
                          if (busy) {
                            busy.dismiss();
                          }
                          this.openPaymentSelection();
                        }, 750);
                      }
                    });
                  }
                }
              );
              // }
            } else {
              this._newRegister(null, null, true, _feeTypeSelected, _membershipNo).then(
                async (registered: any) => {
                  if (registered < 0) return;
                  console.debug('_newRegister : ', registered);
                  const busy = await this.loadingCtl.create({
                    message: 'Redirecting to payment page...',
                    backdropDismiss: false,
                  });
                  busy.present().then(() => {
                    if (registered) {
                      setTimeout(() => {
                        if (busy) {
                          busy.dismiss();
                        }
                        this.openPaymentSelection();
                      }, 750);
                    }
                  });
                }
              );
            }
          }
        }
      }
    });
  }

  getApplicableFeeType() {
    const _compPlayer = this.playerViews?.filter(
      cp => cp?.player?.id === this.session?.playerId
    )[0];

    // if(_compPlayer) {
    //   if(_compPlayer?.feeTypeSelected === 'Auto' && _compPlayer?.golfClubMembership) return 'ClubMember';
    //   else if(_compPlayer?.feeTypeSelected === 'Auto' && (!_compPlayer?.golfClubMembership || _compPlayer?.golfClubMembership?.length === 0)) return 'Standard';
    //   else return _compPlayer?.feeTypeSelected;
    // } else {
    return this.currentFeeApplicable?.feeType;
    // }
  }

  getDerivedFeeType(feeType: string) {
    if (!this.compData && feeType === 'Standard') {
      return 'Non-Member';
    } else if (!this.compData) {
      return feeType;
    }
    if (feeType === 'Standard') {
      return 'Non-Member';
    } else if (feeType?.toLowerCase().includes('club')) {
      return this.compData?.club?.tag + ' Member (Club)';
    } else if (feeType?.toLowerCase().includes('organizer')) {
      return (
        (this.compData?.organizer?.shortName || this.compData?.organizer?.name) +
        ' Member (Organizer)'
      );
    }
  }

  async onClickMatchplayNonDetailedScoring() {
    console.debug(
      'on comp scoring click',
      this.currentRound,
      this.details,
      this.competition,
      this.gameRound,
      this.getPlayerStatus()
    );
    if (!this.currentRound) {
      return;
    }
    if (!this.compData) {
      return;
    }
    if (this.compData && !this.compId) {
      return;
    }
    if (this.getPlayerStatus() === 'Withdrawn') {
      const _msg = 'You have Withdrawn from the competition. Please go to View Scorecard instead';
      this.onShowMessage('Scorecard', _msg);
      return false;
    }
    if (1) {
      [await this.getCompMatches()];
      // return;
    }

    // let loader = await this.loadingCtl.create({
    //   message: "Getting scorecard. Please wait...",
    //   backdropDismiss: false
    // });
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    let _competitionId;
    let _isScorer;
    // this.scorecardService.clearScorecard().subscribe((scorecard)=>{

    // });

    const _today = moment().format('YYYY-MM-DD');
    const _startDate = moment(this.competition.startDate).format('YYYY-MM-DD');
    const _endDate = moment(this.competition.endDate).format('YYYY-MM-DD');

    if (_startDate > _today && _endDate < _today) {
      const _msg = 'Competition is not active anymore';

      console.debug('on comp scoring [1] ', _msg);
      this.onErrorMessage('Scorecard', _msg);
      return false;
    } else if (_endDate < _today) {
      const _msg = 'Competition is not active anymore';
      // MessageDisplayUtil.showErrorToast(
      //   _msg,
      //   this.platform,
      //   this.toastCtl,
      //   3000,
      //   'bottom'
      // );
      console.debug('on comp scoring [2] ', _msg);
      this.onErrorMessage('Scorecard', _msg);
      return false;
    }

    console.debug('going to matchplay scoring - active match', this.playerMatches);

    if (this.playerMatches?.length === 0) {
      MessageDisplayUtil.showMessageToast(
        'You have no Active Matches, please view Leaderboard page for progress',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return;
    }
    setTimeout(() => {
      const navigationExtras: NavigationExtras = {
        state: {
          // scorecard: scorecard,
          competition: this.competition,
          compData: this.compData,
          playerMatch: this.playerMatches[0],

          // compId: this.compId,
          // currentPlayer: _player,
          // editingScorecard:
          //   _isScorer && _isScorer.length > 0
          //     ? true
          //     : false,
        },
      };
      this.router.navigate(['matchplay-scoring'], navigationExtras);
    }, 500);
  }

  competitionMatches: Array<CompetitionMatch>;
  playerMatches: Array<CompetitionMatch>;
  getCompMatches() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    this.flightService
      .getCompMatches(this.compData?.id, this.currentRound)
      .subscribe((compMatches: Array<CompetitionMatch>) => {
        console.debug('get comp matches', compMatches);

        this.competitionMatches = compMatches;
        const _currentPlayerMatches = compMatches?.filter(
          (cm: CompetitionMatch) =>
            cm?.participants?.some((p: CompetitionMatchParticipant) => {
              return p?.player?.id === _player?.playerId;
            }) &&
            (cm?.status === 'InProgress' ||
              cm?.status === 'Pending' ||
              cm?.status === 'Completed' ||
              cm?.status === 'Submitted')
        );
        if (_currentPlayerMatches?.length > 0) {
          //this.playerMatches = _currentPlayerMatches;
          this.playerMatches = _currentPlayerMatches
            ?.filter((pm: CompetitionMatch) => pm?.status !== 'Abandoned')
            .sort((a: CompetitionMatch, b: CompetitionMatch) => {
              if (a?.status === 'InProgress' && b?.status === 'Pending') {
                return -1;
              } else if (a?.status === 'Pending' && b?.status === 'InProgress') {
                return 1;
              } else {
                if (a?.startTime < b?.startTime) {
                  return -1;
                } else if (a?.startTime > b?.startTime) {
                  return 1;
                } else {
                  return 0;
                }
              }
            });
        }
        console.debug(
          'get comp matches - current player ',
          compMatches,
          _player,
          _currentPlayerMatches,
          this.playerMatches
        );
      });
  }

  goMatchPlayLeaderboard() {
    // this._refreshCompetitionInfo(null);
    if (this.competition.status == 'Upcoming' || this.competition.status == 'Not Started') {
      // let subTitle =
      //   'Competition has not started. Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        '',
        'Competition has not started. Please refresh to view latest competition status.'
      );
      return false;
    }
    if (!this.competition.showLeaderBoard && this.competition.status != 'Completed') {
      // let subTitle =
      //   'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage(
        'Leaderboard',
        'Leaderboard is disabled by the Organizer. It will be available once the competition is completed.<br> Please refresh to update competition status.'
      );
      return false;
    }
    if (this.currentRound == null) {
      this.currentRound = this.details.roundInProgress;
      if (!this.currentRound) {
        this.currentRound = this.details.nextRound;
      }
    }
    if (this.currentRound != null) {
      const navigationExtras: NavigationExtras = {
        state: {
          competition: this.competition,
          compId: this.compId,
          leaderboards: this.leaderBoard,
          leaderboardPlayers: this.leaderBoard.players,
          roundNo: this.currentRound,
          categories: this.details.categories,
          teams: this.competition.teamEvent ? null : null,
          showTeam: this.showTeam,
          compData: this.compData,
        },
      };
      this.router.navigate(['tabs/competition-matchplay-leaderboard'], navigationExtras);
    }
  }

  goCompMatches() {
    // if (this.gameRound.status === 'Pending') {
    //   this._refreshCompetitionInfo(null, 'refreshFlight');
    //   return false;
    // }

    if (this.competitionMatches?.length < 1) {
      const subTitle = 'No matches have been defined for this round'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Matches', subTitle);
      return false;
      /*  let alert = Alert.create({
       title: 'No Flights',
       subTitle: 'There is no flight assigned for this competition',
       buttons: ['OK']
       });
       this.nav.present(alert);*/
    } else {
      this.gameRound = this.details.gameRounds
        .filter((gr: GameRoundInfo, idx: number) => gr.roundNo == this.currentRound)
        .pop();
      const navigationExtras: NavigationExtras = {
        state: {
          competitionId: this.compId,
          competition: this.competition,
          compId: this.compId,
          roundNo: this.gameRound.roundNo,
          compData: this.compData,
          competitionMatches: this.competitionMatches,
          currentRound: this.currentRound,
        },
      };
      this.router.navigate(['tabs/competition-matches'], navigationExtras);
    }
  }
  goTeamPlayers() {
    if (this.compTeams === null || this.compTeams?.length == 0) {
      const subTitle = 'No teams have been assigned to this competition'; //'Flights have not been defined for this competition yet';
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, '', subTitle, 'OK');
      this.onErrorMessage('Teams', subTitle);
      return false;
    } else {
      const navigationExtras: NavigationExtras = {
        state: {
          mode: 'matchTeams',
          compData: this.compData,
          compId: this.compData?.id,
          newCompTeams: this.compTeams,
          compTeamPlayers: this.compTeamPlayersList,
        },
      };
      // alert('Navigation Left to set');
      this.router.navigate(['tabs/competition-teams'], navigationExtras);
    }
  }
  compTeamPlayersList: Array<CompetitionTeamPlayerData> = [];
  getCompTeamPlayers() {
    this.flightService
      .getCompTeamPlayers(this.compData?.id)
      .subscribe((compTeamPlayersList: Array<CompetitionTeamPlayerData>) => {
        if (compTeamPlayersList?.length) {
          this.compTeamPlayersList = compTeamPlayersList;
        }
      });
  }

  subShowLeaderboard: Subscription;
  initWebsocketActions() {
    this.subShowLeaderboard = this.websocketActions
      .subscribeTo(SUBSCRIBE_COMP_SHOW_LEADERBOARD)
      .subscribe((data: any) => {
        console.debug('get update scorer : ', data);
        if (data?.competitionId === this.compData?.id) {
          // this.refreshMatchById();
          this.compData.showLeaderBoard = data?.showLeaderboard;
          this.onRefreshClick(null);
        }
      });
  }

  showToggleFullName = false;
  onToggleFullName() {
    this.showToggleFullName = !this.showToggleFullName;
  }

  parseTimezone(date: any, time: any) {
    const dateTime = `${date}T${time}`;
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    const dt = DateTime.fromISO(dateTime, { zone: clubTimeZone });
    const gmt = `GMT${dt.offset >= 0 ? '+' : ''}${dt.offset / 60}`;
    const display = `${dt.toFormat('hh:mm a')} (${gmt})`;
    return display;
  }

  getCurrentTimeZone() {
    // if (!!timeZone) return momentTz().tz(timeZone).format('YYYY-MM-DD HH:mm:ss');
    // else return momentTz().format('YYYY-MM-DD HH:mm:ss');
    const dt = DateTime.now();
    const gmt = `GMT${dt.offset >= 0 ? '+' : ''}${dt.offset / 60}`;

    const display = `${dt.toFormat('hh:mm a')} (${gmt})`;
    return display;
    // if (!!timeZone) return DateTime.now().setZone(timeZone).toFormat('yyyy-MM-dd hh:mm a');
    // else return DateTime.now().toFormat('yyyy-MM-dd hh:mm a');
  }

  devMode() {
    return global.devMode;
  }

  subNewCompTeams: Subscription;
  refreshCompetitionTeams(loader?, refresher?, attribute?: string) {
    if (this.subNewCompTeams) {
      return;
    }
    // this.compService.getCompetitionTeams(this.compId).subscribe(
    this.subNewCompTeams = this.flightService.getNewCompetitionTeams(this.compId).subscribe(
      (compTeams: Array<CompetitionTeamWithPlayersView>) => {
        console.debug('get comp teams : ', compTeams);
        this.compTeams = compTeams;
        if (this.currentRound == null) {
          this.currentRound = this.details.roundInProgress;
          if (!this.currentRound) {
            this.currentRound = this.details.nextRound;
          }
        }

        if (this.currentRound != null) {
          // this.compService
          //   .getFlights(
          this.flightService.getCompFlightList(this.compId, this.currentRound).subscribe(
            (flights: any) => {
              this.flights = flights;

              loader.dismiss().then(() => {
                this._onRefreshComplete();
                if (attribute === 'refreshFlight') {
                  this.goFlights(attribute);
                }
              });
            },
            error => {
              loader.dismiss();
            }
          );
        } else {
          loader.dismiss();
          adjustViewZIndex(this.nav, this.renderer);
        }
      },
      error => {
        //Error getting comp teams

        if (this.subNewCompTeams) {
          this.subNewCompTeams.unsubscribe();
          this.subNewCompTeams = null;
        }
        loader.dismiss().then(() => {
          this._onRefreshComplete();
        });
      },
      () => {
        if (this.subNewCompTeams) {
          this.subNewCompTeams.unsubscribe();
          this.subNewCompTeams = null;
        }
      }
    );
  }

  registeredPlayers;
  getRegisteredPlayers() {
    this.flightService.getCompRegisteredPlayers(this.compId).subscribe({
      next: data => {
        this.registeredPlayers = data;
        // this.compData.players = data;
      },
      error: error => {},
    });
  }

  playerViews: Array<CompetitionPlayerFullView> = [];

  async getRegisteredPlayerViews() {
    const loader = await this.loadingCtl.create({
      message: 'Please wait...',
      // message: 'Loading player list, Please wait...',
      duration: 5000,
      backdropDismiss: true,
    });
    loader.present();
    this.flightService
      .getCompPlayersView(this.compId)
      .pipe(
        finalize(() => {
          let _player;
          this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
            if (player) {
              _player = player;
            }
          });
          this.playerIsPlaying = this.playerViews?.filter(
            (compPlayer: CompetitionPlayerFullView) => {
              if (compPlayer?.player?.id && _player?.playerId) {
                return compPlayer?.player?.id === _player?.playerId;
              } else {
                return false;
              }
            }
          );
          if (loader) {
            loader.dismiss();
          }
        })
      )
      .subscribe((players: Array<CompetitionPlayerFullView & any>) => {
        this.playerViews = players;
        // this.compData.players = players;
      });
  }

  getCompSponsorsList() {
    this.flightService.getCompetitionSponsorsList(this.compId).subscribe({
      next: (data: Array<CompetitionSponsorData>) => {
        this.compSponsorsList = data;
      },
      error: error => {},
    });
  }

  compWaitList: Array<CompetitionWaitList> = [];
  getCompWaitList() {
    this.flightService
      .getCompetitionWaitList(this.compId)
      .subscribe((data: Array<CompetitionWaitList>) => {
        this.compWaitList = data;
      });
  }

  refreshFlightsList() {
    this.flightService
      .getCompFlightList(this.compId, this.currentRound)
      .subscribe((flights: any) => {
        this.flights = flights;
        // flights.filter(flight => {
        //   _playerInFlight = flight.flightMembers.filter(flightMember => {
        //     return flightMember?.player?.playerId === _player.playerId;
        //   });
        // });
      });
  }

  isTeamOnly() {
    return (
      this.compData?.teamEvent &&
      !this.compData?.addlSettings?.teamEventRules?.allPlayerScoresRequired
    );
  }

  async goScrambleScorecard() {
    const teamFlightScores = await this.getCompTeamRoundScores(this.compData?.id);
    let _player;
    this.player$.pipe(take(1)).subscribe(player => {
      _player = player;
    });
    if (teamFlightScores) {
      // this.onDismissPageLoader();
      const navigationExtras: NavigationExtras = {
        state: {
          compData: this.compData,
          competition: this.competition,
          // playerMatch: matches[0],
          flightScores: teamFlightScores,
          compId: this.compData?.id,
          currentPlayer: _player?.player,
          editingScorecard: true,
        },
      };
      await this.router.navigate(['scramble-scoring'], navigationExtras);
    }
  }

  private getCompTeamRoundScores(compId: number, roundNo: number = 1) {
    return new Promise((resolve, reject) => {
      let _player: PlayerInfo;
      this.player$.pipe(take(1)).subscribe(player => {
        _player = player;
      });

      this.flightService
        .getTeamRoundScoresByPlayerFlight(compId, roundNo, _player?.playerId)
        .subscribe(
          (teamRoundScores: CompetitionTeamRoundFlight) => {
            if (teamRoundScores) {
              resolve(teamRoundScores);
            } else {
              reject(false);
            }
          },
          error => {
            reject(error);
          }
        );
    });
  }

  playerAdditionalInfo: any;
  async goFillMissingInfo(requireMandatory?: boolean) {
    try {
      let _done = false;
      // this.flightService.getCompPlayerAdditionalInfo(this.compData?.id, 199).subscribe(data => {});
      // const formDetails = await this.getCompetitionAdditionalInfo();

      let _player;
      this.player$.pipe(take(1)).subscribe(async (player: PlayerInfo) => {
        if (player) {
          _player = player;
        }
      });
      const compPlayer = await this.getCompPlayerAdditionalInfo();
      const playerAdditionalInfo = await this.convertAdditionalInfo(compPlayer);
      return this.onFillMissingInfo(requireMandatory, playerAdditionalInfo);

      // const _editMode = false; //this.needPayment() && this.getMissingInfoForm() > 0;
      // const modal = await this.modalCtl.create({
      //   component: CompetitionFormModalPage,
      //   componentProps: {
      //     player: this.playerDetails, //_player,
      //     friend: false,
      //     formId: this.compAddInfoForm?.id,
      //     formDefinition: this.compAddInfoForm?.formObj,
      //     playerAdditionalInfo: playerAdditionalInfo,
      //     compData: this.compData,
      //     requireMandatory: requireMandatory,
      //     viewMode: _editMode,
      //     playerDetails: this.playerDetails,
      //   },
      // });
      // modal.present();

      // const result = await modal.onDidDismiss();
      // if (result && result?.data?.proceedRegister) {
      //   if (this.isRegistered()) {
      //     this.compService.setPlayerIsRegistered(true);
      //     this.refreshCompData();
      //   } else {
      //     this.refreshCompData();
      //   }
      //   return true;
      // } else {
      //   return false;
      // }
    } catch (error) {
      return this.onFillMissingInfo(requireMandatory);
    }
  }

  async onFillMissingInfo(requireMandatory?: boolean, playerAdditionalInfo?: any) {
    if (this.isWaitListed()) {
      this.goingToPay = false;
      return;
    }
    if (this.isRegistered()) this.compService.setPlayerIsRegistered(true);
    try {
      const _editMode = false; //this.needPayment() && this.getMissingInfoForm() > 0;
      const modal = await this.modalCtl.create({
        component: CompetitionFormModalPage,
        componentProps: {
          player: this.playerDetails, //_player,
          friend: false,
          formId: this.compAddInfoForm?.id,
          formDefinition: this.compAddInfoForm?.formObj,
          playerAdditionalInfo: playerAdditionalInfo,
          compData: this.compData,
          requireMandatory: requireMandatory,
          viewMode: _editMode,
          playerDetails: this.playerDetails,
        },
      });
      modal.present();
      const result = await modal.onDidDismiss();
      console.debug('dismiss on fill missing info : ', result);
      if (result && result?.data?.proceedRegister) {
        if (this.isRegistered()) {
          this.compService.setPlayerIsRegistered(true);
          this.refreshCompData();
        } else {
          this.refreshCompData();
        }
        return true;
      } else {
        if (this.goingToPay) {
          this.goingToPay = false;
        }
        return false;
      }
    } catch (error) {
      if (this.goingToPay) {
        this.goingToPay = false;
      }
      return true;
    }
  }

  canRegister() {
    return true;
    // const searchCriteria = this.compService.getSearch();
    // let _subId = null;
    // this.customizerService.getSubsidiary().subscribe(subId => {
    //   _subId = subId;
    // });
    // // console.debug('can register?', _subId, searchCriteria);
    // if (_subId === searchCriteria?.wagcCountry?.tag) return true;
    // return false;
  }

  getRegisterPlayerInfo() {
    // this.flight
  }

  compAddInfoForm: any;
  groupAddInfo: any;
  async getCompetitionAdditionalInfo() {
    if (!this.compData?.playerFormId) {
      return null;
    } // reject(true);
    const formId: number = this.compData.playerFormId;

    try {
      const formDetails = await firstValueFrom(this.flightService.getDynamicFormById(formId));

      if (formDetails) {
        this.compAddInfoForm = formDetails;
        const form: DynamicForm = JSON.parse(formDetails?.formDefinition);
        this.compAddInfoForm.formObj = JSON.parse(formDetails?.formDefinition);
        this.groupAddInfo = this.constructDynamicForms(form);
        // console.debug('additional info form : ', formDetails, form);
        return {
          formId: formId,
          formDefinition: form,
        };
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching form details', error);
      return null;
    }
  }

  compPlayerForm: any;
  async getCompPlayerAdditionalInfo() {
    //   // this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
    //   //   if (player) _player = player;
    //   //   console.debug('get comp player add info : ', player, _player, this.compData);
    //     const playerForm = await firstValueFrom(
    //       this.flightService.getCompPlayerAdditionalInfo(this.compData?.id, _player?.playerId)
    //     );
    //   // });

    try {
      let _player = await firstValueFrom(
        this.player$.pipe(
          filter(player => !!player), // skip null/undefined
          take(1)
        )
      );
      if (!this.compData?.id) {
        console.warn('compData not ready yet');
        return null;
      }
      // console.debug('get comp player add info : ', _player, this.compData);
      // const playerForm = await this.playerViews?.find(player => {
      //   return player?.player?.id === _player?.playerId;
      // });
      const playerForm = await firstValueFrom(
        this.flightService.getCompPlayerAdditionalInfo(this.compData?.id, _player?.playerId)
      );
      if (playerForm) {
        this.compPlayerForm = playerForm;

        this.playerAdditionalInfo = await this.convertAdditionalInfo(playerForm);
        return playerForm;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async validateAdditionalInfoForm() {
    // console.debug(
    //   'validate add info : ',
    //   this.compPlayerForm,
    //   this.compAddInfoForm,
    //   this.playerAdditionalInfo
    // );
    if (!this.compAddInfoForm) {
      return false;
    }
    let _failed = true;
    if (this.playerAdditionalInfo) {
      await this.compAddInfoForm?.formObj.fields.forEach(fld => {
        if (
          fld.required &&
          (this.playerAdditionalInfo[fld.name]?.length === 0 ||
            this.playerAdditionalInfo[fld.name] === null)
        ) {
          // console.debug(
          //   'validate add info [0]: ',
          //   fld,
          //   this.playerAdditionalInfo[fld.name]?.length
          // );
          _failed = true;
        }
      });
      return _failed;
    } else {
      return _failed;
    }
  }

  getMissingInfoForm() {
    // if (!this.compAddInfoForm) return 0;
    // console.debug('missing info [000] : ', this.playerAdditionalInfo);
    let _counter = 0;
    if (this.playerAdditionalInfo) {
      this.compAddInfoForm?.formObj.fields.forEach(fld => {
        if (
          fld.required &&
          (this.playerAdditionalInfo[fld.name]?.length === 0 ||
            this.playerAdditionalInfo[fld.name] === null ||
            this.playerAdditionalInfo[fld.name] === undefined ||
            this.playerAdditionalInfo[fld.name] === 'null')
        ) {
          // console.debug('missing info : ', fld, this.playerAdditionalInfo);
          _counter++;
        }
      });
    } else {
      this.compAddInfoForm?.formObj.fields.forEach(fld => {
        if (fld.required) {
          _counter++;
        }
      });
    }
    return _counter;
  }

  convertAdditionalInfo(compPlayer) {
    // const obj = Object.fromEntries(new URLSearchParams(compPlayer?.additionalInfo));
    const obj = JSON.parse(compPlayer?.additionalInfo);
    return obj;
  }
  playerDetails: PlayerData;
  getPlayerDetails() {
    return new Promise((resolve, reject) => {
      let _player;
      this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        console.debug('loading player : ', _player);
      });

      this.flightService.getPlayerDetails(_player?.playerId).subscribe(data => {
        if (data) {
          this.playerDetails = data;
          resolve(data);
        }
      });
    });
  }
  contentsList: Array<any> = [];
  getCompContentsList() {
    this.contentsList = [];
    this.flightService.getCompContentList(this.compData?.id).subscribe(eventsList => {
      this.contentsList = eventsList;
    });
  }

  setOutstandingAmount() {
    this.outstandingAmount = 0;
    const _tournamentFee = this.compData?.tournamentFee;
    const _orgMemberFee = this.compData?.tournamentFeeOrgMember;
    const _clubMemberFee = this.compData?.tournamentFeeClubMember;

    const _paidAmount = this.currentFeeApplicable?.paymentAmount || 0;
    if (this.getPaymentStatus() === 'Full') {
      if (this.currentFeeApplicable?.feeType === 'Standard') {
        if (_paidAmount !== _tournamentFee) {
          this.outstandingAmount = Number(_tournamentFee) - Number(_paidAmount);
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('club')) {
        if (_paidAmount !== _clubMemberFee) {
          this.outstandingAmount = Number(_clubMemberFee) - Number(_paidAmount);
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('organizer')) {
        if (_paidAmount !== _orgMemberFee) {
          this.outstandingAmount = Number(_orgMemberFee) - Number(_paidAmount);
        }
      } else {
        if (this.currentFeeApplicable?.applicableFee !== _tournamentFee) {
          this.outstandingAmount = Number(_tournamentFee) - Number(_paidAmount);
        }
      }
    } else {
      if (this.currentFeeApplicable?.feeType === 'Standard') {
        if (_paidAmount !== _tournamentFee) {
          this.outstandingAmount = Number(_tournamentFee);
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('club')) {
        if (_paidAmount !== _clubMemberFee) {
          this.outstandingAmount = Number(_clubMemberFee);
        }
      } else if (this.currentFeeApplicable?.feeType?.toLowerCase().includes('organizer')) {
        if (_paidAmount !== _orgMemberFee) {
          this.outstandingAmount = Number(_orgMemberFee);
        }
      } else {
        if (this.currentFeeApplicable?.applicableFee !== _tournamentFee) {
          this.outstandingAmount = Number(_tournamentFee);
        }
      }
    }
    // else {
    //   this.outstandingAmount = 0;
    // }
  }
  async goDisplayMessage(title: string, message: string) {
    const modal = await this.modalCtl.create({
      component: CommonPullupMenuComponent,

      cssClass: this.platform.is('mobile')
        ? 'self-adjustable-modal'
        : 'self-adjustable-modal-desktop',
      componentProps: {
        app: null,
        mode: 'infoDisplay',
        headerTitle: title,
        message,
      },
      mode: 'ios',
    });

    modal.onDidDismiss().then(async data => {
      // this.onRefreshClick(null);
    });
    await modal.present().then();
  }

  parseTextWithLinks(text: string): string {
    if (!text) {
      return '';
    }

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(
      urlRegex,
      url => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
    );
  }

  constructDynamicForms(data: any) {
    const groupedData = [];
    let currentGroup = null;

    // Create a default group for fields before the first separator
    currentGroup = {
      name: 'additionalInfo',
      display: data.title,
      description: '',
      fields: [],
    };
    groupedData.push(currentGroup);

    data.fields.forEach(field => {
      if (field.type === 'separator') {
        currentGroup = {
          name: field.name,
          display: field.properties.sectionTitle,
          description: field.properties.sectionDescription,
          fields: [],
        };
        groupedData.push(currentGroup);
      } else {
        if (field?.hint) {
          field.hint = this.parseTextWithLinks(field.hint);
        }
        if (field?.tooltip) {
          field.tooltip = this.parseTextWithLinks(field.tooltip);
        }
        // This handles the case where the first fields are not under a separator
        if (currentGroup) {
          currentGroup.fields.push(field);
        }
      }
    });

    return groupedData;
  }

  hasHandicapUploadForm() {
    if (!this.groupAddInfo) {
      return;
    }
    if (!this.groupAddInfo?.length) return;
    const _hasHandicap = this.groupAddInfo?.find(addInfo => {
      return addInfo?.name?.toLowerCase()?.includes('handicapupload');
    });
    // console.debug('has handicap upload : ', this.groupAddInfo, _hasHandicap);
    return _hasHandicap;
  }

  async goFillHandicapUpload(requireMandatory?: boolean) {
    try {
      const _done: boolean = false;
      // this.flightService.getCompPlayerAdditionalInfo(this.compData?.id, 199).subscribe(data => {});
      // const formDetails = await this.getCompetitionAdditionalInfo();

      let _player;
      this.player$.pipe(take(1)).subscribe(async (player: PlayerInfo) => {
        if (player) {
          _player = player;
        }
      });
      const compPlayer = await this.getCompPlayerAdditionalInfo();
      const playerAdditionalInfo = await this.convertAdditionalInfo(compPlayer);
      return this.onFillHandicapUpload(requireMandatory, playerAdditionalInfo);
    } catch (error) {
      return this.onFillHandicapUpload(requireMandatory);
    }
  }

  async onFillHandicapUpload(requireMandatory?: boolean, playerAdditionalInfo?: any) {
    if (this.isWaitListed()) {
      this.goingToPay = false;
      return;
    }
    if (this.isRegistered()) this.compService.setPlayerIsRegistered(true);
    try {
      const _editMode = false; //this.needPayment() && this.getMissingInfoForm() > 0;
      const modal = await this.modalCtl.create({
        component: CompetitionFormModalPage,
        componentProps: {
          player: this.playerDetails, //_player,
          friend: false,
          formId: this.compAddInfoForm?.id,
          formDefinition: this.compAddInfoForm?.formObj,
          playerAdditionalInfo: playerAdditionalInfo,
          compData: this.compData,
          requireMandatory: requireMandatory,
          viewMode: _editMode,
          playerDetails: this.playerDetails,
          allowedForms: ['handicapUpload'],
          titleHeader: 'Handicap Upload',
        },
      });
      modal.present();
      const result = await modal.onDidDismiss();
      console.debug('dismiss on fill missing info : ', result);
      if (result && result?.data?.proceedRegister) {
        if (this.isRegistered()) {
          this.compService.setPlayerIsRegistered(true);
          this.refreshCompData();
        } else {
          this.refreshCompData();
        }
        return true;
      } else {
        if (this.goingToPay) {
          this.goingToPay = false;
        }
        return false;
      }
    } catch (error) {
      if (this.goingToPay) {
        this.goingToPay = false;
      }
      return true;
    }
  }

  appendDummyData() {
    // if(1) return;
    if (!this.compData) return;
    // this.compData.paymentD = '2026-04-17T12:03:00';
    // this.compData.autoCancellation = true;
    // this.compData.cancellationGuardPeriod = 45; //in minutes
  }

  getCancellationDueText() {
    if (!this.compData) return;
    if (this.compData?.cancelOnPaymentDefault) {
      return `to avoid Auto De-Registration`;
    } else return;
  }
  getPaymentDueText(late: boolean = false) {
    if (!this.compData) return '';
    if (!this.compData?.paymentDueOn) {
      return '';
      // return 'before ' + moment(
      //   this.compData?.closeDate + ' ' + this.compData?.registrationCloseTime,
      //   'YYYY-MM-DD HH:mm:ss'
      // ).format('ddd, DD MMM YYYY hh:mm A');
    }
    const _compPlayer = this.playerViews?.filter(
      cp => cp?.player?.id === this.session?.playerId
    )[0];
    let registrationDateTime = _compPlayer?.registeredAt; //  '2026-04-16T12:00:00';
    // if(late) {
    //   registrationDateTime = '2026-04-17T12:10:00';
    // }

    const paymentDueDateTime = this.compData.paymentDueOn;
    const clubTimeZone = this.compData?.club?.timeZone?.id;
    // const openDateTime = `${this.compData?.openDate}T${this.compData?.registrationOpenTime}`;
    // const closeDateTime = `${this.compData?.closeDate}T${this.compData?.registrationCloseTime}`;
    const paymentTime = DateTime.fromISO(paymentDueDateTime, { zone: clubTimeZone });
    // const openTime = DateTime.fromISO(openDateTime, { zone: clubTimeZone });
    // const closeTime = DateTime.fromISO(closeDateTime, { zone: clubTimeZone });
    const currTime = DateTime.now();
    const registrationTime = DateTime.fromISO(registrationDateTime, { zone: clubTimeZone });

    if (!this.compData?.cancelOnPaymentDefault && registrationTime.toUTC() >= paymentTime.toUTC()) {
      return 'overdue';
    }
    if (!_compPlayer && currTime.toUTC() >= paymentTime.toUTC()) {
      return `within ${this.compData?.cancelGuardMins} minutes ${this.getCancellationDueText()}`;
    }
    if (registrationTime.toUTC() >= paymentTime.toUTC()) {
      return `within ${this.compData?.cancelGuardMins} minutes ${this.getCancellationDueText()}`;
    } else {
      const _date = paymentTime.toFormat('yyyy-MM-dd'); // paymentDueDateTime.split('T')[0];
      const _time = paymentTime.toFormat('HH:mm:ss'); // paymentDueDateTime.split('T')[1];
      const _dateTime = this.parseTimezone(_date, _time);
      const _convDateTime = paymentTime.toFormat(`EEE, dd MMM`);
      return `before ${_convDateTime} ${_dateTime}`;
    }
  }

  async onProgramsClick() {
    if (this.contentsList?.length === 1) {
      let _eventDetails;
      await this.flightService
        .getCompContentById(this.compData?.id, this.contentsList[0]?.id)
        .subscribe(async content => {
          console.debug('event details ', event, _eventDetails);
          const eventModal: any = await this.modalCtl.create({
            component: CompEventsDetailsComponent,
            cssClass: 'full-screen-modal',
            componentProps: {
              event: content,
            },
          });

          eventModal.onDidDismiss((data: any) => {
            if (data) {
            }
          });
          eventModal.present();
        });
    } else {
      const _params: NavigationExtras = {
        state: {
          clubId: global.clubId,
          organizerId: global.organizerId,
          competitionId: this.compData?.id,
        },
      };
      this.router.navigate(['comp-events-list'], _params);
    }
  }
}
